// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.container {
  padding: 0px !important;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
}

.close-ico {
  position: absolute;
  top: 15px;
  right: 25px;
  color: white;
  z-index: 10;
  text-align: right;
}

.close-ico .fal {
  font-size: 25px;
  padding-right: 15px;
  padding-top: 5px;
}

.flow-info-panel {
  display: flex;
  overflow-x: auto;
  gap: 12px;
  padding: 0 12px;
}
.flow-info-panel::-webkit-scrollbar {
  height: 4px;
}
.flow-info-panel::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  border-radius: 4px;
}
.flow-info-panel::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.box {
  max-width: 360px;
  width: 100% !important;
  margin: 10px;
  padding: 0px 25px;
  background: #fff;
  background-size: 50%;
  background-position: top center;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
  overflow: hidden;
  background: "https://flowchest-cdn.azureedge.net/mediaimage/Screenshot 2023-05-05 1448027cea2b039f4a4049a42ef2bcf6c81c54.png";
  background-size: cover;
  background-position: center;
  border-radius: 15px 15px 0px 0px;
  margin: 0px auto;
  background-repeat: no-repeat !important;
  background-size: contain !important;
  background-size: 100% 90%;
  background-position: top center;
}

.box-wrap {
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 30px 0px;
  display: flex;
  flex-wrap: wrap;
}

.box:after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  background: rgba(0, 0, 0, 0.5);
}

* {
  padding: 0px;
  margin: 0px;
}

body {
  background: #efeeee;
  counter-reset: my-sec-counter;
}

.view-flow {
  background: #efeeee;
  min-height: 89vh;
  padding-top: 10px;
}

.flowbycat {
  height: 100%;
  display: table;
  text-align: center;
}

header {
  width: 100%;
  height: 100px;
  background: #fff;
  border-bottom: 2px solid #5ea1d8;
}

.container1 {
  max-width: 1040px;
  margin: 0px auto;
  background: transparent;
  padding-bottom: 30px;
  padding: 0px 40px 20px;
}

.user-sec {
  padding: 20px 20px;
  background: #fff;
  border: 1px solid #ddd;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  margin: 0px 20px 0px 20px;
  border-radius: 10px;
  position: relative;
}

.user-details {
  flex: 1;
  display: flex;
}

.user-ico {
  flex: 1;
  display: none !important;
}
.user-ico img {
  width: 180px !important;
  height: 180px;
  border-radius: 100%;
  object-fit: cover;
  max-width: 200px;
}

.ico-details {
  flex: 4;
  padding-left: 0px;
  display: flex;
  flex-direction: column;
}
.ico-details p {
  margin-bottom: 20px !important;
  margin-top: 0px !important;
}
.ico-details .profilepic {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.ico-details .profilepic .profinner {
  max-width: 500px;
  width: 100%;
  display: flex;
}
.ico-details .profilepic .profinner > div {
  width: auto;
  margin-right: 20px;
}
.ico-details .profilepic .profinner > div:last-child span {
  color: #212427 !important;
  font-weight: 400 !important;
}
.ico-details .profilepic .profinner > div:last-child span .mat-icon {
  color: #212427 !important;
  font-size: 18px;
  display: flex;
  align-items: center;
}
.ico-details .profilepic .u-ico {
  margin-right: 15px;
}
.ico-details .profilepic .qrcode {
  flex: 1;
  justify-content: flex-end;
  align-items: flex-end;
  color: #212427 !important;
}
.ico-details .profilepic .qrcode span {
  font-weight: 400 !important;
}
.ico-details .profilepic p {
  margin: 0px !important;
}
.ico-details .profilepic > div {
  display: flex;
  align-items: center;
  margin-right: 20px;
}
.ico-details .profilepic > div:last-child {
  margin-right: 0px;
}
.ico-details .profilepic img {
  border-radius: 50%;
  cursor: pointer;
}

.like {
  max-width: 100%;
  margin-bottom: 0px;
  display: flex;
}
.like span.material-icons {
  min-height: 30px;
  color: #212427 !important;
}

.qr-ico {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
  position: absolute;
  right: 20px;
}

.qr-ico i {
  flex: 1;
  font-size: 25px;
  color: grey;
  color: #212427;
}

.qr-ico p {
  font-weight: 600;
}

img {
  width: 100%;
}

p {
  font-family: "Raleway";
  font-size: 15px;
  line-height: 20px;
}

button {
  padding: 3px 10px;
  background: #5ea1d8;
  border: 0px;
  color: #fff;
  font-size: 15px;
  border-radius: 5px;
}

h2 {
  font-family: "Raleway";
  margin-bottom: 20px;
}

h3 {
  font-family: "Raleway";
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
}

ul {
  display: flex;
  list-style: none;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

li {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
li span {
  margin-left: 0px;
}

.like .qrcode {
  flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}

.like ul {
  max-width: 500px;
  width: 100%;
  display: flex;
  margin-left: -17px;
}

.like li {
  height: 100%;
  justify-content: flex-start;
}

.like li i {
  font-size: 25px;
  color: gray;
  text-shadow: 0px 2px 2px rgba(186, 183, 183, 0.4);
  margin-bottom: 5px;
}

li span {
  font-size: 10px;
  font-family: "Raleway";
  font-weight: 600;
  text-align: center;
  color: #212427 !important;
  padding: 0px !important;
}

/*description wrapper starts here*/
.description-wrapper {
  display: flex;
  background: #fff;
  margin: 10px 20px 10px 20px;
}

.des-item {
  flex-basis: calc(50% - 20px);
  margin-right: 10px;
  display: flex;
  flex-direction: column;
}

.des-item .des {
  /*max-height:200px;*/
  flex: 1;
  border: 1px solid #ddd;
  margin-bottom: 0px;
  border-radius: 0px;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
}

.des-item .des p {
  max-height: 100px;
  overflow-y: auto;
}

.des-item .des > div {
  flex: 1;
  display: flex;
  align-items: flex-start;
  margin-top: 20px;
}

.des-item .des > div span {
  flex: 1;
  font-family: "RALEWAY";
}

.des-item .des > div span.material-icons.ng-star-inserted {
  max-width: 30px;
}

.des-item .des > div span:first-child {
  align-items: flex-start;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.des-item .des > div span:last-child {
  text-align: flex-end;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.des-item .des > div span i {
  margin-right: 5px;
}

.des-item .item {
  flex: 1;
  border: 1px solid #ddd;
  border-radius: 40px;
  padding: 40px 20px;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  margin-top: 20px;
}

.des-item .item .list {
  display: flex;
  /* padding: 20px 0px; */
  max-height: 150px;
  overflow-y: auto;
  align-items: flex-start;
}

.des-item .item .list ul {
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 0px 0px 20px;
  padding: 5px;
}

.des-item .item .list ul li {
  font-family: "Raleway";
  font-size: 14px;
  line-height: 28px;
  word-break: break-all;
  position: relative;
  padding-left: 17px;
}
.des-item .item .list ul li:before {
  content: "";
  width: 8px;
  height: 8px;
  background: grey;
  position: absolute;
  left: 0px;
  top: 10px;
  border-radius: 50%;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
}
.des-item .item .list ul li:first-child {
  padding-left: 0px;
}
.des-item .item .list ul li:first-child:before {
  display: none;
}

.des-item .item .list ul li:first-child {
  font-weight: 600;
}

.step-sec {
  flex: 1;
  padding: 40px;
  border: 1px solid #ddd;
  border-radius: 40px;
}

.step-sec .img-wrap {
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
}
.step-sec .img-wrap img {
  max-width: 100% !important;
  height: 100%;
  margin: 0px auto;
  width: 100% !important;
}
.step-sec .img-wrap video {
  max-width: 100% !important;
  margin: 0px auto;
  width: 100% !important;
}
.step-sec .img-wrap:empty {
  display: none !important;
}

.step-sec .img-wrap:after {
  content: "›";
  background: #fafafa !important;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  position: absolute;
  right: -49px;
  top: calc(50% - 20px);
  font-size: 35px;
  margin-top: -8px;
  display: none;
}

.step-sec .img-wrap:before {
  content: "‹";
  background: #fafafa !important;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  position: absolute;
  left: -49px;
  top: calc(50% - 20px);
  font-size: 35px;
  margin-top: -8px;
  display: none;
}

.des-item .des p::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}

.des-item .des p::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.des-item .des p::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}

.des-item .item .list::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}

.des-item .item .list::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.des-item .item .list::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}

.step-sec {
  display: flex;
  flex-direction: column;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
}

.progressbar ul {
  display: flex;
  flex-basis: 100%;
}

.progressbar ul li {
  flex: 1;
  display: flex;
  align-items: center;
}

.progressbar ul li a {
  width: 20px;
  height: 20px;
  background: #5ea1d8;
  border-radius: 50%;
  color: #fff;
  text-decoration: none;
  text-align: center;
  font-size: 12px;
  font-family: "RALEWAY";
  display: flex;
  align-items: center;
  justify-content: center;
}

.progressbar ul li a:before {
  counter-increment: my-sec-counter;
  content: "" counter(my-sec-counter) "";
}

img {
  max-width: 100%;
}

/*new added*/
.viewflow-step {
  width: calc(100% - 40px);
  display: flex;
  padding: 20px 20px;
  border: 1px solid #ddd;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  position: relative;
  border-radius: 10px;
  flex-wrap: wrap;
}
.viewflow-step .des-item {
  border-radius: 0px;
  border-right: 1px solid lightgray;
  max-width: calc(50% - 20px);
  padding-right: 10px;
}
.viewflow-step .des-item .des {
  box-shadow: none;
  border: 0px;
  padding: 0px 0px;
}
.viewflow-step .des-item .des h6 {
  font-weight: bold;
  margin-bottom: 5px;
}
.viewflow-step .des-item .des > div {
  flex: none;
  flex-wrap: wrap;
}
.viewflow-step .des-item .des p {
  max-height: 287px;
  padding-right: 10px;
}
.viewflow-step .des-item .des .s-num {
  font-size: 16px;
  width: 30px;
  height: 30px;
  color: #fff;
  border: 0px solid #f3f3f3;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-family: "Raleway";
  font-weight: 600;
  margin-top: 0px;
  margin-bottom: 20px;
  position: relative;
  z-index: 2;
}
.viewflow-step .des-item .des .s-num:before {
  content: "";
  width: 100%;
  height: 100%;
  border-radius: 50%;
  left: 0px;
  top: 0px;
  position: absolute;
  background: lightgray;
  z-index: -1;
}
.viewflow-step .step-sec {
  box-shadow: none;
  border: 0px;
  padding: 0px 0px 0px 0px;
  margin-left: 10px;
  width: 50%;
}
.viewflow-step .step-sec .progressbar {
  border: 2px solid lightgray;
  margin-bottom: 20px;
  background: #fff;
  border-radius: 10px;
  padding: 5px;
}
.viewflow-step .step-sec .progressbar .w3-round {
  height: 7px;
  background: #5ea1d8;
  background: lightgrey;
}
.viewflow-step .clickarrow {
  width: 100%;
  display: block;
  position: absolute;
  margin-top: 0px;
  width: 100%;
  height: 35px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
.viewflow-step .clickarrow button.owl-prev {
  position: absolute;
  background: #fafafa !important;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  left: -45px;
}
.viewflow-step .clickarrow button.owl-prev span {
  font-size: 35px;
  line-height: 0px;
  display: flex;
  align-items: center;
  margin-top: -8px;
  color: #000;
}
.viewflow-step .clickarrow button.owl-next {
  position: absolute;
  background: #fafafa !important;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  right: -45px;
}
.viewflow-step .clickarrow button.owl-next span {
  font-size: 35px;
  line-height: 0px;
  display: flex;
  align-items: center;
  margin-top: -8px;
  color: #000;
}

@media only screen and (max-width: 1025px) and (min-width: 320px) {
  .view-flow h2 {
    font-size: 22px !important;
  }
}
@media only screen and (max-width: 992px) and (min-width: 320px) {
  .view-flow .container1 {
    display: flex;
    flex-direction: column;
    padding: 0px 15px 20px;
  }
  .view-flow .container1 .user-sec {
    flex-direction: row;
  }
  .view-flow .container1 .user-sec .user-details {
    flex-direction: column;
    order: 2;
  }
  .view-flow .container1 .user-sec .user-details .user-ico {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .view-flow .container1 .user-sec .user-details .ico-details {
    padding: 0px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic > div p {
    font-size: 14px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like {
    display: flex;
    flex-direction: column;
    margin-left: 0px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like ul {
    margin-left: 0px;
    max-width: 100%;
    margin-bottom: 10px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like ul li i {
    font-size: 20px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like .qrcode span {
    margin-right: 0px !important;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like .qrcode p {
    margin-bottom: 0px !important;
  }
  .view-flow .container1 .user-sec .qr-code {
    padding: 10px 0px;
  }
  .view-flow .description-wrapper {
    flex-direction: column;
    margin: 0px;
    margin-bottom: 20px;
  }
  .view-flow .description-wrapper .des-item {
    margin-right: 0px;
    margin-bottom: 20px;
    flex-basis: 100%;
    max-width: unset;
    border-right: 0px;
    padding-right: 0px;
  }
  .view-flow .description-wrapper .des-item .des > div span:first-child {
    justify-content: flex-start;
  }
  .view-flow .description-wrapper .des-item .des .timer-wrap {
    display: flex;
    flex-direction: column;
    flex: none;
    color: #212427;
  }
  .view-flow .description-wrapper .des-item .des .timer-wrap > * {
    margin-right: 10px;
  }
  .view-flow .viewflow-step {
    width: 100%;
    margin: 0px auto 20px;
  }
  .view-flow .viewflow-step .des-item {
    flex-basis: 100%;
    max-width: unset;
    border-bottom: 2px solid lightgrey;
    padding-bottom: 0px;
    border-bottom: 0px;
  }
  .view-flow .viewflow-step .des-item .des {
    padding-bottom: 0px;
    border-radius: 0px;
  }
  .view-flow .viewflow-step .step-sec {
    padding: 0px;
    margin-left: 0px;
    width: 100%;
  }
  .view-flow .viewflow-step .clickarrow button {
    width: 25px;
    height: 25px;
  }
  .qr-ico {
    position: relative;
    right: 0px;
  }
}
/*table struture starts here*/
.table-wrap {
  max-height: 260px;
  overflow-y: auto;
  padding-right: 7px;
}
.table-wrap::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}
.table-wrap::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.table-wrap::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}

table {
  padding-right: 20px;
  width: 100%;
}
table tr {
  display: flex;
  width: 100%;
  flex-flow: row wrap;
  justify-content: space-between;
}
table tr th {
  font-family: "Raleway";
  font-weight: 600 !important;
  font-size: 16px !important;
  width: 48%;
  word-break: break-all;
  margin-bottom: 15px;
  line-height: 25px;
}
table tr td {
  width: 100%;
  word-break: break-all;
  margin-bottom: 15px;
  font-family: "Raleway";
  font-weight: 400;
  line-height: 25px;
  font-size: 13px;
  position: relative;
  padding-left: 15px;
  display: flex;
}
table tr td > span {
  width: 48%;
  overflow-wrap: break-word;
}
table tr td > span:first-child {
  margin-right: 4%;
}
table tr td:before {
  content: "";
  width: 8px;
  height: 8px;
  background: grey;
  position: absolute;
  left: 0px;
  top: 8px;
  border-radius: 50%;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
}

.btm-btn {
  display: flex;
  align-items: center;
}
.btm-btn > div {
  flex: 1;
}
.btm-btn > div:first-child {
  justify-content: flex-start;
}
.btm-btn > div:last-child {
  justify-content: right;
  text-align: end;
}
.btm-btn .lock {
  display: flex;
  align-items: center;
  font-family: "Raleway";
}
.btm-btn .lock > span {
  display: flex;
  align-items: center;
}

.profilepic .lock {
  display: block;
}

.like-list .fashion-btn {
  display: block;
}

.qr-code .lock,
.qr-code .fashion-btn {
  display: none;
}

@media only screen and (max-width: 992px) and (min-width: 461px) {
  .view-flow .container1 .user-sec .user-details {
    flex-direction: row;
  }
  .view-flow .container1 .user-sec .user-details .ico-details {
    padding-left: 15px;
    max-width: 100%;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like ul {
    margin-left: -15px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like .qrcode span {
    margin-right: 15px !important;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic > div p {
    font-size: 14px !important;
  }
  .view-flow .container1 .description-wrapper {
    width: auto;
    margin: 10px 0px;
  }
  .view-flow .container1 .description-wrapper .step-sec .img-wrap {
    max-height: unset;
  }
  .view-flow .container1 .viewflow-step .des-item .des {
    padding-bottom: 20px;
    border-radius: 0px;
  }
  .view-flow .container1 .viewflow-step .clickarrow button.owl-next {
    right: -35px;
  }
  .view-flow .container1 .viewflow-step .clickarrow button.owl-prev {
    left: -35px;
  }
}
@media only screen and (max-width: 992px) and (min-width: 768px) {
  .view-flow .viewflow-step .clickarrow button {
    width: 35px;
    height: 35px;
  }
  .view-flow .viewflow-step .clickarrow button.owl-prev {
    left: -45px;
  }
  .view-flow .viewflow-step .clickarrow button.owl-next {
    right: -45px;
  }
}
@media only screen and (max-width: 460px) and (min-width: 320px) {
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic > div p {
    font-size: 11px !important;
  }
  .ico-details .profilepic > div:last-child span {
    font-size: 11px;
  }
  .view-flow .viewflow-step .clickarrow button {
    width: 25px;
    height: 25px;
  }
  .view-flow .viewflow-step .clickarrow button.owl-prev {
    left: -30px;
  }
  .view-flow .viewflow-step .clickarrow button.owl-next {
    right: -30px;
  }
  .view-flow .viewflow-step {
    width: auto;
    margin: 10px 20px;
  }
  .qr-code {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .qr-code .lock > span {
    display: flex;
    align-items: center;
  }
  .qr-code .lock .priceIcon-p {
    top: -2px;
  }
  .qr-code .lock,
  .qr-code .fashion-btn {
    display: block;
  }
  .profilepic .lock {
    display: none !important;
  }
  .like-list .fashion-btn {
    display: none !important;
  }
  .view-flow h2 span {
    font-size: 20px !important;
    word-break: break-word;
  }
  .view-flow .container1 .user-sec {
    padding: 10px;
  }
  .ico-details .profilepic .profinner > div {
    margin-right: 5px;
  }
  .ico-details .profilepic > div {
    margin-right: 0px;
  }
  .like li:last-child {
    display: none !important;
  }
  .viewflow-step .des-item .des p {
    max-height: 133px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like ul li span {
    font-size: 9px;
  }
}
button.common {
  padding: 3px 6px !important;
  background: #5ea1d8 !important;
  border: 0px !important;
  color: #fff !important;
  font-size: 13px !important;
  border-radius: 5px !important;
}

@media (max-width: 500px) {
  .ico-details .profilepic .qrcode {
    justify-content: center;
  }
}
.example-list {
  max-width: 100%;
  height: auto;
  display: block;
  background: white;
  overflow-y: auto;
}
.example-list .example-box {
  display: flex;
  padding: 15px 10px;
  border-bottom: 1px solid lightgrey;
  background: white !important;
}
.example-list .example-box .item-name {
  text-align: left;
  width: 70%;
}
.example-list .example-box .item-value {
  text-align: left;
  width: 30%;
}
.example-list .example-box .item-name,
.example-list .example-box .item-delete,
.example-list .example-box .item-reorder,
.example-list .example-box .item-value {
  text-align: left;
  padding: 5px;
  font-size: 14px;
  font-weight: 400 !important;
  overflow-wrap: break-word;
}
.example-list .example-box .item-delete,
.example-list .example-box .item-reorder {
  float: right;
  cursor: pointer;
  font-size: 20px;
  width: 10%;
}
.example-list .example-box:last-child {
  border-bottom: 0px;
}
.example-list::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}
.example-list::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.example-list::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}

.example-box {
  padding: 15px 10px;
  border-bottom: solid 1px lightgray;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: move;
  background: white;
  font-size: 14px;
}
.example-box > div {
  width: 50%;
  display: flex !important;
}
.example-box > div:first-child {
  width: 80%;
}
.example-box > div:last-child {
  width: 17%;
}
.example-box > div > span {
  text-align: left;
  word-break: keep-all;
  display: flex;
  align-items: center;
}
.example-box > div > span:first-child {
  flex: 1;
  width: 50%;
  color: rgba(0, 0, 0, 0.54) !important;
  font-weight: 400 !important;
}
.example-box > div > span:last-child {
  width: 50%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: end;
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.54) !important;
  font-weight: 400 !important;
}

.itemremove span:first-child {
  width: 90% !important;
}
.itemremove span:nth-child(2) {
  display: none;
}

.img-div-left {
  position: fixed;
  z-index: 9999999 !important;
  height: 100px;
  width: 100px;
  overflow: visible;
  margin: auto;
  top: 5% !important;
  left: 0;
  bottom: 0;
  right: 0;
}
.img-div-left img {
  width: 100%;
  height: 100%;
  position: absolute !important;
  top: 0% !important;
}

.card {
  height: 100px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  width: 30%;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.card {
  width: calc(50% - 30px);
  box-shadow: none;
  margin: 40px auto 0px auto;
  height: auto !important;
}
.card .container {
  padding: 5px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

/*new design starts here new bundle*/
@media (max-width: 460px) {
  .viewbundle .step-sec + .row > div {
    width: 50% !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon {
    display: flex;
    align-items: center;
  }
  .viewbundle .step-sec + .row > div .item .with-icon > div {
    width: 30px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon img {
    margin: 0px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon p {
    padding-left: 5px !important;
  }
}
@media only screen and (min-width: 461px) and (max-width: 767px) {
  .viewbundle .step-sec + .row > div {
    width: 33% !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon {
    display: flex;
    align-items: center;
  }
  .viewbundle .step-sec + .row > div .item .with-icon > div {
    width: 30px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon img {
    margin: 0px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon p {
    padding-left: 5px !important;
  }
}
.bundleIcon {
  bottom: 10px;
  right: 10px;
  z-index: 10;
  width: 25px !important;
  height: 25px !important;
  max-width: 25px !important;
  height: 25px !important;
  margin-left: 10px;
}
.bundleIcon img {
  width: 100% !important;
  height: auto !important;
  object-fit: contain;
  border: none;
}

.ico-details .profilepic .uni-wrapper {
  display: flex;
  width: auto;
  align-items: center;
}
.ico-details .profilepic .uni-wrapper P {
  flex: 1;
}

@media only screen and (max-width: 767px) and (min-width: 320px) {
  .view-flow .container1 .user-sec {
    margin: 0px;
  }
  .view-flow .viewflow-step {
    margin: 10px 0px;
  }
  .ico-details .profilepic .qrcode {
    justify-content: right;
  }
}
/*new design add 14-05-2022*/
/* new common design add*/
.flobycategoryadd .user-pro .flowbycategory-row {
  width: calc(100% - 40px);
  margin: 0px 20px !important;
}
.flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile {
  width: 18.6%;
  margin-right: 1%;
}
.flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile .item {
  width: 100% !important;
  overflow: hidden;
  background: #fff;
  border: 1px solid #dddddd;
  margin: 0px;
  margin-right: 20px;
  margin-bottom: 20px;
  height: 95%;
  position: relative;
  padding: 10px !important;
}
.flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile .item div {
  margin: 0px !important;
}
.flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile .item p {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 35px !important;
  white-space: normal;
  word-break: break-word;
  display: flex;
  align-items: flex-start;
  margin-top: 0px !important;
  line-height: 18px !important;
  margin-left: 5px;
}
.flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile .item .uni-wrapper {
  display: flex;
  width: 100%;
  align-items: center;
}
.flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile .item .with-icon {
  width: 100%;
  font-family: "Raleway";
  display: flex;
  align-items: center;
  margin: 0px !important;
}
.flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile .item .with-icon img {
  object-fit: cover;
  height: 40px !important;
  border: 0px;
  margin: 0px !important;
}
.flobycategoryadd .user-pro .flowbycategory-row video.video-display[poster] {
  height: 100% !important;
  padding-bottom: 12%;
  max-height: 100% !important;
  max-width: 100% !important;
  width: 100% !important;
  text-align: center;
  cursor: pointer;
  min-height: 150px !important;
}
.flobycategoryadd .mat-sidenav-content {
  background: #efeeee !important;
  min-height: 89vh !important;
  padding: 2rem 3rem !important;
  padding-top: 0px !important;
}

@media only screen and (max-width: 992px) and (min-width: 320px) {
  .supportingdoc {
    position: relative !important;
    padding: 10px 10px 10px 0px !important;
  }
}
@media only screen and (max-width: 992px) and (min-width: 768px) {
  .flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile {
    max-width: 23% !important;
    width: 23% !important;
  }
  .view-flow .container1 .description-wrapper {
    margin: 10px 20px !important;
  }
}
@media only screen and (max-width: 767px) and (min-width: 320px) {
  .flobycategoryadd .user-pro .flowbycategory-row {
    width: 100%;
    margin: 0px !important;
  }
  .flobycategoryadd .mat-sidenav-content {
    background: #efeeee !important;
    min-height: 89vh !important;
    padding: 2rem 10px !important;
    padding-top: 0px !important;
  }
}
@media only screen and (max-width: 767px) and (min-width: 461px) {
  .flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile {
    max-width: 31.3% !important;
    width: 31.3% !important;
    margin: 1%;
  }
}
@media screen and (max-width: 460px) {
  .flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile {
    max-width: 48% !important;
    width: 48% !important;
    margin: 1%;
  }
}
.qrcode .uni-wrapper p .common {
  background: #e83e8c !important;
}

.view-flow .partOfBundle {
  padding: 0px 20px 20px;
  background: #fff;
  background: transparent;
  margin: 0px 20px 0px 0px;
  border-radius: 10px;
  overflow-x: scroll;
}
.view-flow .partOfBundle h2 {
  font-size: 2rem;
  line-height: 1.2;
  margin-bottom: 0px !important;
}

.flobycategoryadd .user-pro .flowbycategory-row {
  width: calc(100% - 0px);
  margin: 0px 0px 0px 0px !important;
}

.newdesignadd {
  border: 0px !important;
  padding: 0px !important;
}

.not-draggable {
  -webkit-user-drag: none; /* Safari/Chrome */ /* Firefox */ /* IE10+ */
  -webkit-user-select: none;
          user-select: none; /* Standard syntax */
  cursor: default; /* Optional: Change the cursor style */
  transform: translate(0, 0) !important;
  width: 100%;
}

.divscroll {
  width: 100% !important;
  display: flex;
  flex-direction: row;
  height: 100px;
  overflow-y: auto;
  overflow-x: hidden;
}
.divscroll div {
  width: 100% !important;
}

@media (max-width: 767px) {
  .partOfBundle {
    padding: 0px 0px 20px 0px !important;
    margin-right: 0px !important;
  }
  .partOfBundle h2 {
    margin-top: 0px !important;
  }
  .view-flow .container1 .viewflow-step {
    margin-bottom: 10px !important;
  }
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner div:nth-child(4) {
  position: relative;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner div:nth-child(4) span {
  position: relative !important;
}

@media (max-width: 767px) {
  .priceIcon-wp {
    position: relative !important;
  }
  .qr-code .fashion-btn + .fashion-btn {
    display: none !important;
  }
}
.qrcode.mobview {
  display: none;
}

@media (max-width: 767px) {
  .qrcode.mobview {
    display: flex;
    align-items: center;
  }
  .qrcode.mobview p {
    margin-bottom: 0px !important;
  }
  .desktopview {
    display: none;
  }
}
.btn-wrap {
  height: 35px;
  font-size: 14px;
  cursor: pointer;
  color: white;
  background-color: #5ea1d8;
  border-radius: 5px;
}

.action-buttons-container {
  display: flex;
  justify-content: center;
  padding: 20px;
  gap: 20px;
}

.mobile-stacked-view {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 20px;
  background: #f6f7f9;
}

.mobile-top-panel {
  position: sticky;
  top: 76px;
  z-index: 3;
  padding: 12px 0 4px;
  background: linear-gradient(180deg, rgba(246, 247, 249, 0.98) 0%, rgba(246, 247, 249, 0.9) 60%, rgba(246, 247, 249, 0) 100%);
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
}

.mobile-info-panel {
  padding: 0 12px;
  display: flex;
  overflow-x: auto;
  gap: 12px;
}
.mobile-info-panel .info-badge {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 500;
  color: #606060;
  white-space: nowrap;
}
.mobile-info-panel .info-badge.active {
  background: #5ea1d8;
  color: #ffffff;
  border-color: #5ea1d8;
}
.mobile-info-panel .info-badge .info-icon {
  font-size: 16px;
}
.mobile-info-panel .info-badge .info-label {
  font-family: "Raleway", sans-serif;
}

.mobile-info-panel::-webkit-scrollbar {
  display: none;
}

.mobile-section {
  background: #ffffff;
  border-radius: 16px;
  overflow: visible;
  scroll-margin-top: 140px;
}
.mobile-section .mobile-media {
  overflow: hidden;
  border-radius: 16px 16px 0 0;
}

.mobile-media {
  background: #000;
}
.mobile-media img,
.mobile-media video {
  width: 100%;
  display: block;
  max-height: 260px;
  object-fit: cover;
}

.mobile-media-video {
  width: 100%;
  max-height: 260px;
  background: #000;
  border: 0;
}

.mobile-section-body {
  padding: 20px 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.mobile-section-body > * {
  margin-left: 0;
  margin-right: 0;
}

.mobile-section-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  padding: 0;
  color: #1f2f46;
  line-height: 1.4;
}

.mobile-section-description {
  color: #4a5568;
  line-height: 1.6;
  margin: 0;
  padding: 0;
}
.mobile-section-description p {
  margin: 0 0 12px 0;
  padding: 0;
}
.mobile-section-description p:last-child {
  margin-bottom: 0;
}

.mobile-meta-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0;
  padding: 0;
}
.mobile-meta-row .channel-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex: 1;
  min-width: 0;
  margin: 0;
  padding: 0;
}
.mobile-meta-row .channel-header .channel-avatar {
  flex-shrink: 0;
}
.mobile-meta-row .channel-header .channel-avatar img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
}
.mobile-meta-row .channel-header .channel-avatar .material-icons {
  font-size: 40px;
  width: 40px;
  height: 40px;
  color: #606060;
  cursor: pointer;
}
.mobile-meta-row .channel-header .channel-details {
  flex: 1;
  min-width: 0;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.mobile-meta-row .channel-header .channel-details .channel-name {
  font-size: 14px;
  font-weight: 500;
  color: #0f0f0f;
  cursor: pointer;
  margin: 0 0 2px 0;
  padding: 0;
  font-family: "Raleway", sans-serif;
  line-height: 1.4;
  text-align: left;
  width: 100%;
}
.mobile-meta-row .channel-header .channel-details .channel-name:hover {
  color: #606060;
}
.mobile-meta-row .channel-header .channel-details .channel-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  font-size: 12px;
  color: #606060;
  font-family: "Raleway", sans-serif;
  margin: 0;
  padding: 0;
  width: 100%;
  text-align: left;
}
.mobile-meta-row .channel-header .channel-details .channel-meta mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.mobile-meta-row .channel-header .channel-details .channel-meta .price-tag {
  color: #e83e8c;
  cursor: pointer;
  font-weight: 500;
}
.mobile-meta-row .channel-header .channel-details .channel-meta .price-tag:hover {
  text-decoration: underline;
}
.mobile-meta-row .channel-header .channel-details .channel-meta .purchased-tag {
  color: #606060;
  background: #f2f2f2;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
}
.mobile-meta-row .channel-header .channel-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.mobile-meta-row .channel-header .channel-actions .follow-btn {
  padding: 8px 14px;
  border-radius: 18px;
  border: 1px solid #5ea1d8;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
  white-space: nowrap;
}
.mobile-meta-row .channel-header .channel-actions .follow-btn.following {
  background: #f2f8fc;
  color: #0f0f0f;
  border-color: #5ea1d8;
}
.mobile-meta-row .channel-header .channel-actions .follow-btn.following:hover {
  background: #e1f0fa;
}
.mobile-meta-row .channel-header .channel-actions .follow-btn:not(.following) {
  background: #5ea1d8;
  color: #ffffff;
  box-shadow: 0 4px 10px rgba(94, 161, 216, 0.35);
}
.mobile-meta-row .channel-header .channel-actions .follow-btn:not(.following):hover {
  background: #4b8ac1;
}
.mobile-meta-row .channel-header .channel-actions .purchase-btn {
  padding: 8px 14px;
  border-radius: 18px;
  border: none;
  background: #e83e8c;
  color: white;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
  white-space: nowrap;
}
.mobile-meta-row .channel-header .channel-actions .purchase-btn:hover {
  background: #d0307a;
}

.mobile-actions-bar {
  display: flex;
  gap: 16px;
  padding: 12px 0;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  margin: 12px 0;
}
.mobile-actions-bar .action-item {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  color: #606060;
  font-size: 14px;
}
.mobile-actions-bar .action-item mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.mobile-actions-bar .action-item mat-icon[style*="#5ea1d8"] {
  color: #5ea1d8 !important;
}
.mobile-actions-bar .action-item .favorite-toggle-icon.liked {
  color: #ff4d4d;
}

.mobile-supporting-doc {
  margin-top: 12px;
  color: #5ea1d8;
  text-decoration: none;
}

.recommendations-list.mobile {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
  width: 100%;
  overflow: visible;
}
.recommendations-list.mobile .recommendation-item {
  display: flex;
  gap: 12px;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.2s;
  background: #ffffff;
  width: 100%;
  box-sizing: border-box;
  min-height: 90px;
}
.recommendations-list.mobile .recommendation-item:hover {
  background: #f9f9f9;
  border-color: #d0d0d0;
}
.recommendations-list.mobile .recommendation-item .recommendation-thumbnail {
  flex-shrink: 0;
  width: 140px;
  height: 90px;
  min-width: 140px;
  min-height: 90px;
  border-radius: 8px;
  overflow: hidden;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.recommendations-list.mobile .recommendation-item .recommendation-thumbnail img,
.recommendations-list.mobile .recommendation-item .recommendation-thumbnail video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.recommendations-list.mobile .recommendation-item .recommendation-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: flex-start;
  overflow: visible;
}
.recommendations-list.mobile .recommendation-item .recommendation-info .recommendation-title {
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  padding: 0;
  color: #0f0f0f;
  line-height: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.recommendations-list.mobile .recommendation-item .recommendation-info .recommendation-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #606060;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
}
.recommendations-list.mobile .recommendation-item .recommendation-info .recommendation-meta .recommendation-creator,
.recommendations-list.mobile .recommendation-item .recommendation-info .recommendation-meta .recommendation-id {
  font-family: "Raleway", sans-serif;
  white-space: nowrap;
}
.recommendations-list.mobile .recommendation-item .recommendation-info .recommendation-price {
  margin-top: auto;
  font-weight: 600;
  color: #e83e8c;
  font-size: 14px;
  padding: 0;
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/view-reported-bundle/view-reported-bundle.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAEF;;AACA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AAEF;;AACA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;AAEF;;AACA;EACE,aAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;AAEF;AAAE;EACE,WAAA;AAEJ;AACE;EACE,yBAAA;EACA,kBAAA;AACJ;AAEE;EACE,mBAAA;EACA,kBAAA;AAAJ;;AAIA;EACE,gBAAA;EACA,sBAAA;EAGA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8EAAA;EACA,gBAAA;EACA,6HAAA;EACA,sBAAA;EACA,2BAAA;EACA,gCAAA;EACA,gBAAA;EACA,uCAAA;EACA,mCAAA;EACA,yBAAA;EACA,+BAAA;AAHF;;AAMA;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AAHF;;AAMA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,8BAAA;AAHF;;AAMA;EACE,YAAA;EACA,WAAA;AAHF;;AAKA;EACE,mBAAA;EACA,6BAAA;AAFF;;AAIA;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AADF;;AAGA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;AAAF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,gCAAA;AACF;;AACA;EACE,iBAAA;EACA,gBAAA;EAEA,uBAAA;EACA,oBAAA;EACA,sBAAA;AACF;;AACA;EAEE,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iDAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AACA;EACE,OAAA;EACA,aAAA;AAEF;;AAAA;EACE,OAAA;EACA,wBAAA;AAGF;AAFE;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAIJ;;AADA;EACE,OAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AAIF;AAFE;EACE,8BAAA;EACA,0BAAA;AAIJ;AAFE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAIJ;AAHI;EACE,gBAAA;EACA,WAAA;EACA,aAAA;AAKN;AAHM;EACE,WAAA;EACA,kBAAA;AAKR;AAHU;EACE,yBAAA;EACA,2BAAA;AAKZ;AAJY;EACE,yBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAMd;AACI;EACE,kBAAA;AACN;AACI;EACE,OAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;AACN;AAAM;EACE,2BAAA;AAER;AACI;EACE,sBAAA;AACN;AACI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AACN;AAAM;EACE,iBAAA;AAER;AACI;EACE,kBAAA;EACA,eAAA;AACN;;AAGA;EACE,eAAA;EACA,kBAAA;EACA,aAAA;AAAF;AACE;EACE,gBAAA;EACA,yBAAA;AACJ;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAFF;;AAIA;EACE,OAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;AADF;;AAGA;EACE,gBAAA;AAAF;;AA6BA;EACE,WAAA;AA1BF;;AA6BA;EACE,sBAAA;EACA,eAAA;EACA,iBAAA;AA1BF;;AA4BA;EACE,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAzBF;;AA4BA;EACE,sBAAA;EACA,mBAAA;AAzBF;;AA2BA;EACE,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAxBF;;AA2BA;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;AAxBF;;AA0BA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAvBF;AAwBE;EACE,gBAAA;AAtBJ;;AA0BE;EACE,OAAA;EACA,aAAA;EACA,qBAAA;EACA,yBAAA;AAvBJ;;AA0BA;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AAvBF;;AAyBA;EACE,YAAA;EACA,2BAAA;AAtBF;;AAwBA;EACE,eAAA;EACA,WAAA;EACA,iDAAA;EACA,kBAAA;AArBF;;AAuBA;EACE,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;AApBF;;AAuBA,kCAAA;AACA;EACE,aAAA;EACA,gBAAA;EACA,2BAAA;AApBF;;AAsBA;EACE,4BAAA;EAEA,kBAAA;EACA,aAAA;EACA,sBAAA;AApBF;;AAsBA;EACE,oBAAA;EACA,OAAA;EACA,sBAAA;EACA,kBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,iDAAA;AApBF;;AAsBA;EACE,iBAAA;EACA,gBAAA;AAnBF;;AAsBA;EACE,OAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AAnBF;;AAqBA;EACE,OAAA;EACA,sBAAA;AAlBF;;AAoBA;EACE,eAAA;AAjBF;;AAmBA;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AAhBF;;AAkBA;EACE,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAfF;;AAiBA;EACE,iBAAA;AAdF;;AAgBA;EACE,OAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iDAAA;EACA,gBAAA;AAbF;;AAeA;EACE,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AAZF;;AAcA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,oBAAA;EACA,YAAA;AAXF;;AAaA;EACE,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EAEA,kBAAA;AAXF;AAYE;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,iDAAA;AAVJ;AAYE;EACE,iBAAA;AAVJ;AAWI;EACE,aAAA;AATN;;AAaA;EACE,gBAAA;AAVF;;AAYA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AATF;;AAWA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EAEA,kBAAA;EACA,gBAAA;AATF;AAUE;EAEE,0BAAA;EACA,YAAA;EAGA,gBAAA;EACA,sBAAA;AAXJ;AAaE;EAEE,0BAAA;EAEA,gBAAA;EACA,sBAAA;AAbJ;AAeE;EACE,wBAAA;AAbJ;;AAgBA;EACE,YAAA;EAEA,8BAAA;EACA,iHAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AAfF;;AAiBA;EACE,YAAA;EAEA,8BAAA;EACA,iHAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AAhBF;;AAkBA;EACE,UAAA;EACA,aAAA;AAfF;;AAiBA;EACE,oDAAA;AAdF;;AAgBA;EACE,yBAAA;EACA,0BAAA;AAbF;;AAgBA;EACE,UAAA;EACA,aAAA;AAbF;;AAeA;EACE,oDAAA;AAZF;;AAcA;EACE,yBAAA;EACA,0BAAA;AAXF;;AAcA;EACE,aAAA;EACA,sBAAA;EACA,iDAAA;AAXF;;AAoBA;EACE,aAAA;EACA,gBAAA;AAjBF;;AAmBA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;AAhBF;;AAkBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAfF;;AAiBA;EACE,iCAAA;EACA,sCAAA;AAdF;;AAiBA;EACE,eAAA;AAdF;;AAiBA,YAAA;AACA;EACE,wBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,iDAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAdF;AAgBE;EACE,kBAAA;EACA,iCAAA;EACA,2BAAA;EACA,mBAAA;AAdJ;AAeI;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;AAbN;AAcM;EACE,iBAAA;EACA,kBAAA;AAZR;AAcM;EACE,UAAA;EACA,eAAA;AAZR;AAcM;EACE,iBAAA;EACA,mBAAA;AAZR;AAcM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EAEA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AAbR;AAcQ;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,qBAAA;EAEA,WAAA;AAbV;AAkBE;EACE,gBAAA;EACA,WAAA;EACA,wBAAA;EACA,iBAAA;EACA,UAAA;AAhBJ;AAiBI;EACE,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAfN;AAiBM;EACE,WAAA;EACA,mBAAA;EACA,qBAAA;AAfR;AAuDE;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;AArDJ;AAuDI;EACE,kBAAA;EACA,8BAAA;EACA,iHAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,WAAA;AAtDN;AAuDM;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AArDR;AAwDI;EACE,kBAAA;EACA,8BAAA;EACA,iHAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;AAvDN;AAwDM;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AAtDR;;AA2DA;EAGI;IACE,0BAAA;EA1DJ;AACF;AA8DA;EAEI;IACE,aAAA;IACA,sBAAA;IACA,sBAAA;EA7DJ;EA8DI;IACE,mBAAA;EA5DN;EA+DM;IACE,sBAAA;IACA,QAAA;EA7DR;EA8DQ;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;EA5DV;EA8DQ;IACE,YAAA;EA5DV;EA+Dc;IACE,eAAA;EA7DhB;EAiEU;IACE,aAAA;IACA,sBAAA;IACA,gBAAA;EA/DZ;EAgEY;IACE,gBAAA;IACA,eAAA;IACA,mBAAA;EA9Dd;EAgEgB;IACE,eAAA;EA9DlB;EAmEc;IACE,4BAAA;EAjEhB;EAmEc;IACE,6BAAA;EAjEhB;EAuEM;IACE,iBAAA;EArER;EAyEE;IACE,sBAAA;IACA,WAAA;IACA,mBAAA;EAvEJ;EAwEI;IACE,iBAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;IACA,iBAAA;IACA,kBAAA;EAtEN;EA0EY;IACE,2BAAA;EAxEd;EA4EQ;IACE,aAAA;IACA,sBAAA;IACA,UAAA;IACA,cAAA;EA1EV;EA2EU;IACE,kBAAA;EAzEZ;EAuFE;IACE,WAAA;IACA,qBAAA;EArFJ;EAuFI;IACE,gBAAA;IACA,gBAAA;IACA,kCAAA;IACA,mBAAA;IACA,kBAAA;EArFN;EAuFM;IACE,mBAAA;IAEA,kBAAA;EAtFR;EAyFI;IACE,YAAA;IACA,gBAAA;IACA,WAAA;EAvFN;EA2FM;IACE,WAAA;IACA,YAAA;EAzFR;EAwGA;IACE,kBAAA;IACA,UAAA;EAtGF;AACF;AAyGA,6BAAA;AACA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;AAvGF;AAwGE;EACE,UAAA;EACA,aAAA;AAtGJ;AAwGE;EACE,oDAAA;AAtGJ;AAwGE;EACE,yBAAA;EACA,0BAAA;AAtGJ;;AAyGA;EACE,mBAAA;EACA,WAAA;AAtGF;AAuGE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;AArGJ;AAsGI;EACE,sBAAA;EACA,2BAAA;EACA,0BAAA;EACA,UAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;AApGN;AAsGI;EACE,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AApGN;AAqGM;EACE,UAAA;EACA,yBAAA;AAnGR;AAoGQ;EACE,gBAAA;AAlGV;AAqGM;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,iDAAA;AAnGR;;AA6GA;EACE,aAAA;EACA,mBAAA;AA1GF;AA2GE;EACE,OAAA;AAzGJ;AA0GI;EACE,2BAAA;AAxGN;AA0GI;EACE,sBAAA;EACA,eAAA;AAxGN;AA2GE;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AAzGJ;AA0GI;EACE,aAAA;EACA,mBAAA;AAxGN;;AAkHE;EACE,cAAA;AA/GJ;;AAmHE;EACE,cAAA;AAhHJ;;AAoHE;;EAEE,aAAA;AAjHJ;;AAoHA;EAIQ;IACE,mBAAA;EApHR;EAuHQ;IACE,kBAAA;IACA,eAAA;EArHV;EAuHY;IACE,kBAAA;EArHd;EAwHc;IACE,6BAAA;EAtHhB;EA4Hc;IACE,0BAAA;EA1HhB;EAiII;IACE,WAAA;IAGA,gBAAA;EAjIN;EAoIQ;IACE,iBAAA;EAlIV;EAwIQ;IACE,oBAAA;IAEA,kBAAA;EAvIV;EA2IQ;IACE,YAAA;EAzIV;EA2IQ;IACE,WAAA;EAzIV;AACF;AAgJA;EAIQ;IACE,WAAA;IACA,YAAA;EAjJR;EAkJQ;IACE,WAAA;EAhJV;EAkJQ;IACE,YAAA;EAhJV;AACF;AAsJA;EACE;IAQE,0BAAA;EA3JF;EA8JE;IACE,eAAA;EA5JJ;EAgKE;IACE,WAAA;IACA,YAAA;EA9JJ;EA+JI;IACE,WAAA;EA7JN;EAiKI;IACE,YAAA;EA/JN;EAqKA;IACE,WAAA;IACA,iBAAA;EAnKF;EAqKA;IACE,aAAA;IACA,mBAAA;IACA,8BAAA;EAnKF;EAqKI;IACE,aAAA;IACA,mBAAA;EAnKN;EAqKI;IACE,SAAA;EAnKN;EA4KE;;IAEE,cAAA;EA1KJ;EA+KE;IACE,wBAAA;EA7KJ;EAiLE;IACE,wBAAA;EA/KJ;EAkLA;IACE,0BAAA;IACA,sBAAA;EAhLF;EAkLA;IACE,aAAA;EAhLF;EAkLA;IACE,iBAAA;EAhLF;EAkLA;IACE,iBAAA;EAhLF;EAkLA;IACE,wBAAA;EAhLF;EAkLA;IACE,iBAAA;EAhLF;EAkLA;IACE,cAAA;EAhLF;AACF;AAmLA;EACE,2BAAA;EACA,8BAAA;EAEA,sBAAA;EACA,sBAAA;EACA,0BAAA;EACA,6BAAA;AAlLF;;AAqLA;EACE;IACE,uBAAA;EAlLF;AACF;AAqLA;EACE,eAAA;EAGA,YAAA;EACA,cAAA;EACA,iBAAA;EAEA,gBAAA;AAtLF;AAuLE;EACE,aAAA;EACA,kBAAA;EACA,kCAAA;EACA,4BAAA;AArLJ;AAsLI;EACE,gBAAA;EACA,UAAA;AApLN;AAuLI;EACE,gBAAA;EACA,UAAA;AArLN;AAwLI;;;;EAIE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;AAtLN;AAwLI;;EAEE,YAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;AAtLN;AAwLI;EACE,kBAAA;AAtLN;AAyLE;EACE,UAAA;EACA,aAAA;AAvLJ;AAyLE;EACE,oDAAA;AAvLJ;AAyLE;EACE,yBAAA;EACA,0BAAA;AAvLJ;;AA2LA;EACE,kBAAA;EACA,kCAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAxLF;AAyLE;EACE,UAAA;EACA,wBAAA;AAvLJ;AAwLI;EACE,UAAA;AAtLN;AAwLI;EACE,UAAA;AAtLN;AAwLI;EAEE,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;AAvLN;AAyLM;EACE,OAAA;EACA,UAAA;EACA,qCAAA;EACA,2BAAA;AAvLR;AAyLM;EACE,UAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,qCAAA;EACA,2BAAA;AAvLR;;AA8LI;EACE,qBAAA;AA3LN;AA6LI;EACE,aAAA;AA3LN;;AAgMA;EACE,eAAA;EACA,2BAAA;EACA,aAAA;EACA,YAAA;EAEA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AA9LF;AA+LE;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;AA7LJ;;AAiMA;EACE,aAAA;EACA,0CAAA;EACA,gBAAA;EACA,UAAA;AA9LF;;AAiMA;EACE,2CAAA;AA9LF;;AAiMA;EACE,uBAAA;EACA,gBAAA;EACA,0BAAA;EACA,uBAAA;AA9LF;AA+LE;EACE,iBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AA9LJ;;AAsOA,oCAAA;AA0CA;EAIQ;IACE,qBAAA;EA/QR;EAiRU;IACE,aAAA;IACA,mBAAA;EA/QZ;EAgRY;IACE,sBAAA;EA9Qd;EAgRY;IACE,sBAAA;EA9Qd;EAgRY;IACE,4BAAA;EA9Qd;AACF;AAsRA;EAIQ;IACE,qBAAA;EAvRR;EAyRU;IACE,aAAA;IACA,mBAAA;EAvRZ;EAwRY;IACE,sBAAA;EAtRd;EAwRY;IACE,sBAAA;EAtRd;EAwRY;IACE,4BAAA;EAtRd;AACF;AA+RA;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,uBAAA;EACA,iBAAA;AA7RF;AA8RE;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AA5RJ;;AAgSA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AA7RF;AA8RE;EACE,OAAA;AA5RJ;;AA8UA;EACE;IACE,WAAA;EA3UF;EA6UA;IACE,gBAAA;EA3UF;EA0WA;IACE,sBAAA;EAxWF;AACF;AA2WA,4BAAA;AAEA,yBAAA;AAGE;EACE,wBAAA;EACA,2BAAA;AA5WJ;AA6WI;EACE,YAAA;EACA,gBAAA;AA3WN;AA6WM;EACE,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;AA3WR;AA4WQ;EACE,sBAAA;AA1WV;AA4WQ;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,0BAAA;EACA,4BAAA;EACA,gBAAA;AA1WV;AAgXQ;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AA9WV;AAgXQ;EACE,WAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AA9WV;AA+WU;EAEE,iBAAA;EACA,uBAAA;EACA,WAAA;EACA,sBAAA;AA7WZ;AAkXI;EACE,uBAAA;EACA,mBAAA;EACA,2BAAA;EACA,0BAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;AAhXN;AAmXE;EACE,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,2BAAA;AAjXJ;;AAoXA;EACE;IACE,6BAAA;IACA,sCAAA;EAjXF;AACF;AAmXA;EAIQ;IACE,yBAAA;IACA,qBAAA;EApXR;EA0XA;IACE,4BAAA;EAxXF;AACF;AA0XA;EAGM;IACE,WAAA;IACA,sBAAA;EA1XN;EA8XE;IACE,8BAAA;IACA,2BAAA;IACA,6BAAA;IACA,2BAAA;EA5XJ;AACF;AAgYA;EAIQ;IACE,2BAAA;IACA,uBAAA;IACA,UAAA;EAjYR;AACF;AAsYA;EAIQ;IACE,yBAAA;IACA,qBAAA;IACA,UAAA;EAvYR;AACF;AA+YM;EACE,8BAAA;AA7YR;;AAmZA;EACE,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;AAhZF;AAiZE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;AA/YJ;;AAkZA;EACE,uBAAA;EACA,kCAAA;AA/YF;;AAiZA;EACE,sBAAA;EACA,uBAAA;AA9YF;;AAkZA;EACE,uBAAA,EAAA,kBAAA,EACA,YAAA,EACA,UAAA;EACA,yBAAA;UAAA,iBAAA,EAAA,oBAAA;EACA,eAAA,EAAA,sCAAA;EACA,qCAAA;EACA,WAAA;AA/YF;;AAiZA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AA9YF;AA+YE;EACE,sBAAA;AA7YJ;;AAgZA;EACE;IACE,oCAAA;IACA,4BAAA;EA7YF;EA8YE;IACE,0BAAA;EA5YJ;EA+YA;IACE,8BAAA;EA7YF;AACF;AAsZE;EACE,kBAAA;AApZJ;AAqZI;EACE,6BAAA;AAnZN;;AAuZA;EACE;IACE,6BAAA;EApZF;EAsZA;IACE,wBAAA;EApZF;AACF;AAsZA;EACE,aAAA;AApZF;;AAsZA;EACE;IACE,aAAA;IACA,mBAAA;EAnZF;EAoZE;IACE,6BAAA;EAlZJ;EAqZA;IACE,aAAA;EAnZF;AACF;AAqZA;EACE,YAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AAnZF;;AAsZA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;AAnZF;;AAuZA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AApZF;;AAuZA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,4HAAA;EAMA,kCAAA;UAAA,0BAAA;AAzZF;;AA4ZA;EACE,eAAA;EACA,aAAA;EACA,gBAAA;EACA,SAAA;AAzZF;AA2ZE;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAzZJ;AA2ZI;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAzZN;AA4ZI;EACE,eAAA;AA1ZN;AA6ZI;EACE,kCAAA;AA3ZN;;AAgaA;EACE,aAAA;AA7ZF;;AAgaA;EACE,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,wBAAA;AA7ZF;AAgaE;EACE,gBAAA;EACA,4BAAA;AA9ZJ;;AAkaA;EACE,gBAAA;AA/ZF;AAiaE;;EAEE,WAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AA/ZJ;;AAmaA;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,SAAA;AAhaF;;AAmaA;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAhaF;AAmaE;EACE,cAAA;EACA,eAAA;AAjaJ;;AAqaA;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;AAlaF;;AAqaA;EACE,cAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AAlaF;AAoaE;EACE,kBAAA;EACA,UAAA;AAlaJ;AAoaI;EACE,gBAAA;AAlaN;;AAuaA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AApaF;AAsaE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AApaJ;AAsaI;EACE,cAAA;AApaN;AAsaM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AApaR;AAuaM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAraR;AAyaI;EACE,OAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAvaN;AAyaM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,kCAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AAvaR;AAyaQ;EACE,cAAA;AAvaV;AA2aM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,kCAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AAzaR;AA2aQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAzaV;AA4aQ;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AA1aV;AA4aU;EACE,0BAAA;AA1aZ;AA8aQ;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AA5aV;AAibI;EACE,aAAA;EACA,QAAA;EACA,cAAA;AA/aN;AAibM;EACE,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,4CAAA;EACA,mBAAA;AA/aR;AAibQ;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AA/aV;AAibU;EACE,mBAAA;AA/aZ;AAmbQ;EACE,mBAAA;EACA,cAAA;EACA,+CAAA;AAjbV;AAmbU;EACE,mBAAA;AAjbZ;AAsbM;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;AApbR;AAsbQ;EACE,mBAAA;AApbV;;AA2bA;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,6BAAA;EACA,gCAAA;EACA,cAAA;AAxbF;AA0bE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAxbJ;AA0bI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAxbN;AA4bI;EACE,yBAAA;AA1bN;AA6bI;EACE,cAAA;AA3bN;;AAgcA;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AA7bF;;AAicA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AA9bF;AAgcE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;AA9bJ;AAgcI;EACE,mBAAA;EACA,qBAAA;AA9bN;AAicI;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA/bN;AAicM;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AA/bR;AAmcI;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,2BAAA;EACA,iBAAA;AAjcN;AAmcM;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAjcR;AAocM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;AAlcR;AAocQ;;EAEE,kCAAA;EACA,mBAAA;AAlcV;AAscM;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;AApcR","sourcesContent":[".container {\n  padding: 0px !important;\n  max-height: 90vh;\n  overflow-y: auto;\n  position: relative;\n}\n\n.close-ico {\n  position: absolute;\n  top: 15px;\n  right: 25px;\n  color: white;\n  z-index: 10;\n  text-align: right;\n}\n\n.close-ico .fal {\n  font-size: 25px;\n  padding-right: 15px;\n  padding-top: 5px;\n}\n\n.flow-info-panel {\n  display: flex;\n  overflow-x: auto;\n  gap: 12px;\n  padding: 0 12px;\n\n  &::-webkit-scrollbar {\n    height: 4px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #5ea1d8;\n    border-radius: 4px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n  }\n}\n\n.box {\n  max-width: 360px;\n  width: 100% !important;\n  // max-height:90vh;\n  // min-height:77vh !important;\n  margin: 10px;\n  padding: 0px 25px;\n  background: #fff;\n  background-size: 50%;\n  background-position: top center;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 5px 11px 0 rgb(0 0 0 / 18%), 0 4px 15px 0 rgb(0 0 0 / 15%);\n  overflow: hidden;\n  background: \"https://flowchest-cdn.azureedge.net/mediaimage/Screenshot 2023-05-05 1448027cea2b039f4a4049a42ef2bcf6c81c54.png\";\n  background-size: cover;\n  background-position: center;\n  border-radius: 15px 15px 0px 0px;\n  margin: 0px auto;\n  background-repeat: no-repeat !important;\n  background-size: contain !important;\n  background-size: 100% 90%;\n  background-position: top center;\n}\n\n.box-wrap {\n  position: relative;\n  z-index: 2;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  padding: 30px 0px;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.box:after {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  z-index: 1;\n  background: rgba(0, 0, 0, 0.5);\n}\n\n* {\n  padding: 0px;\n  margin: 0px;\n}\nbody {\n  background: #efeeee;\n  counter-reset: my-sec-counter;\n}\n.view-flow {\n  background: #efeeee;\n  min-height: 89vh;\n  padding-top: 10px;\n}\n.flowbycat {\n  height: 100%;\n  display: table;\n  text-align: center;\n}\nheader {\n  width: 100%;\n  height: 100px;\n  background: #fff;\n  border-bottom: 2px solid #5ea1d8;\n}\n.container1 {\n  max-width: 1040px;\n  margin: 0px auto;\n\n  background: transparent;\n  padding-bottom: 30px;\n  padding: 0px 40px 20px;\n}\n.user-sec {\n  //display: flex;\n  padding: 20px 20px;\n  background: #fff;\n  border: 1px solid #ddd;\n  box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n  margin: 0px 20px 0px 20px;\n  border-radius: 10px;\n  position: relative;\n}\n.user-details {\n  flex: 1;\n  display: flex;\n}\n.user-ico {\n  flex: 1;\n  display: none !important;\n  img {\n    width: 180px !important;\n    height: 180px;\n    border-radius: 100%;\n    object-fit: cover;\n    max-width: 200px;\n  }\n}\n.ico-details {\n  flex: 4;\n  padding-left: 0px;\n  display: flex;\n  flex-direction: column;\n\n  p {\n    margin-bottom: 20px !important;\n    margin-top: 0px !important;\n  }\n  .profilepic {\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n    flex-wrap: wrap;\n    .profinner {\n      max-width: 500px;\n      width: 100%;\n      display: flex;\n\n      & > div {\n        width: auto;\n        margin-right: 20px;\n        &:last-child {\n          span {\n            color: #212427 !important;\n            font-weight: 400 !important;\n            .mat-icon {\n              color: #212427 !important;\n              font-size: 18px;\n              display: flex;\n              align-items: center;\n            }\n          }\n        }\n      }\n    }\n\n    .u-ico {\n      margin-right: 15px;\n    }\n    .qrcode {\n      flex: 1;\n      justify-content: flex-end;\n      align-items: flex-end;\n      color: #212427 !important;\n      span {\n        font-weight: 400 !important;\n      }\n    }\n    p {\n      margin: 0px !important;\n    }\n    & > div {\n      display: flex;\n      align-items: center;\n      margin-right: 20px;\n      &:last-child {\n        margin-right: 0px;\n      }\n    }\n    img {\n      border-radius: 50%;\n      cursor: pointer;\n    }\n  }\n}\n.like {\n  max-width: 100%;\n  margin-bottom: 0px;\n  display: flex;\n  span.material-icons {\n    min-height: 30px;\n    color: #212427 !important;\n  }\n}\n.qr-code {\n  // flex:1;\n}\n.qr-ico {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  height: 100%;\n  position: absolute;\n  right: 20px;\n}\n.qr-ico i {\n  flex: 1;\n  font-size: 25px;\n  color: grey;\n  color: #212427;\n}\n.qr-ico p {\n  font-weight: 600;\n}\n\n// .social-ico {\n//   max-width: 275px;\n//   margin-top: 20px;\n// }\n// .social-ico ul li .fa {\n//   font-size: 27px;\n//   color: gray;\n//   color:#212427;\n//   text-shadow: 0px 2px 2px rgb(186 183 183 / 40%);\n//   margin-bottom: 5px;\n//   font-size: 30px;\n// }\n// .social-ico ul li .fa.fa-facebook-square {\n//   color: #4266b2;\n// }\n\n// .social-ico ul li .fa.fa-twitter-square {\n//   color: #55aded;\n// }\n// .social-ico ul li .fa.fa-linkedin-square {\n//   color: #007ab9;\n// }\n// .social-ico ul li .fa.fa-xing-square {\n//   color: #f96678;\n// }\n\nimg {\n  width: 100%;\n}\n\np {\n  font-family: \"Raleway\";\n  font-size: 15px;\n  line-height: 20px;\n}\nbutton {\n  padding: 3px 10px;\n  background: #5ea1d8;\n  border: 0px;\n  color: #fff;\n  font-size: 15px;\n  border-radius: 5px;\n}\n\nh2 {\n  font-family: \"Raleway\";\n  margin-bottom: 20px;\n}\nh3 {\n  font-family: \"Raleway\";\n  margin-bottom: 20px;\n  font-size: 16px;\n  font-weight: bold;\n}\n\nul {\n  display: flex;\n  list-style: none;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\nli {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  span {\n    margin-left: 0px;\n  }\n}\n.like {\n  .qrcode {\n    flex: 1;\n    display: flex;\n    align-items: flex-end;\n    justify-content: flex-end;\n  }\n}\n.like ul {\n  max-width: 500px;\n  width: 100%;\n  display: flex;\n  margin-left: -17px;\n}\n.like li {\n  height: 100%;\n  justify-content: flex-start;\n}\n.like li i {\n  font-size: 25px;\n  color: gray;\n  text-shadow: 0px 2px 2px rgb(186 183 183 / 40%);\n  margin-bottom: 5px;\n}\nli span {\n  font-size: 10px;\n  font-family: \"Raleway\";\n  font-weight: 600;\n  text-align: center;\n  color: #212427 !important;\n  padding: 0px !important;\n}\n\n/*description wrapper starts here*/\n.description-wrapper {\n  display: flex;\n  background: #fff;\n  margin: 10px 20px 10px 20px;\n}\n.des-item {\n  flex-basis: calc(50% - 20px);\n  // max-width: 3;\n  margin-right: 10px;\n  display: flex;\n  flex-direction: column;\n}\n.des-item .des {\n  /*max-height:200px;*/\n  flex: 1;\n  border: 1px solid #ddd;\n  margin-bottom: 0px;\n\n  border-radius: 0px;\n  padding: 40px 20px;\n  display: flex;\n  flex-direction: column;\n  box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n}\n.des-item .des p {\n  max-height: 100px;\n  overflow-y: auto;\n}\n\n.des-item .des > div {\n  flex: 1;\n  display: flex;\n  align-items: flex-start;\n  margin-top: 20px;\n}\n.des-item .des > div span {\n  flex: 1;\n  font-family: \"RALEWAY\";\n}\n.des-item .des > div span.material-icons.ng-star-inserted {\n  max-width: 30px;\n}\n.des-item .des > div span:first-child {\n  align-items: flex-start;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n.des-item .des > div span:last-child {\n  text-align: flex-end;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n.des-item .des > div span i {\n  margin-right: 5px;\n}\n.des-item .item {\n  flex: 1;\n  border: 1px solid #ddd;\n  border-radius: 40px;\n  padding: 40px 20px;\n  box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n  margin-top: 20px;\n}\n.des-item .item .list {\n  display: flex;\n  /* padding: 20px 0px; */\n  max-height: 150px;\n  overflow-y: auto;\n  align-items: flex-start;\n}\n.des-item .item .list ul {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  margin: 0px 0px 20px;\n  padding: 5px;\n}\n.des-item .item .list ul li {\n  font-family: \"Raleway\";\n  font-size: 14px;\n  line-height: 28px;\n  word-break: break-all;\n  position: relative;\n\n  padding-left: 17px;\n  &:before {\n    content: \"\";\n    width: 8px;\n    height: 8px;\n    background: grey;\n    position: absolute;\n    left: 0px;\n    top: 10px;\n    border-radius: 50%;\n    box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n  }\n  &:first-child {\n    padding-left: 0px;\n    &:before {\n      display: none;\n    }\n  }\n}\n.des-item .item .list ul li:first-child {\n  font-weight: 600;\n}\n.step-sec {\n  flex: 1;\n  padding: 40px;\n  border: 1px solid #ddd;\n  border-radius: 40px;\n}\n.step-sec .img-wrap {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  // max-height: 382px;\n  position: relative;\n  overflow: hidden;\n  img {\n    // width:auto !important;\n    max-width: 100% !important;\n    height: 100%;\n    // object-fit: cover;\n    //max-height: 436px !important;\n    margin: 0px auto;\n    width: 100% !important;\n  }\n  video {\n    // width:auto !important;\n    max-width: 100% !important;\n    //max-height: 300px !important;\n    margin: 0px auto;\n    width: 100% !important;\n  }\n  &:empty {\n    display: none !important;\n  }\n}\n.step-sec .img-wrap:after {\n  content: \"›\";\n\n  background: #fafafa !important;\n  box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%),\n    0 1px 18px 0 rgb(0 0 0 / 12%);\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  position: absolute;\n  right: -49px;\n  top: calc(50% - 20px);\n  font-size: 35px;\n  margin-top: -8px;\n  display: none;\n}\n.step-sec .img-wrap:before {\n  content: \"‹\";\n\n  background: #fafafa !important;\n  box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%),\n    0 1px 18px 0 rgb(0 0 0 / 12%);\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  position: absolute;\n  left: -49px;\n  top: calc(50% - 20px);\n  font-size: 35px;\n  margin-top: -8px;\n  display: none;\n}\n.des-item .des p::-webkit-scrollbar {\n  width: 4px;\n  height: 100px;\n}\n.des-item .des p::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n.des-item .des p::-webkit-scrollbar-thumb {\n  background-color: #5ea1d8;\n  outline: 1px solid #5ea1d8;\n}\n\n.des-item .item .list::-webkit-scrollbar {\n  width: 4px;\n  height: 100px;\n}\n.des-item .item .list::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n.des-item .item .list::-webkit-scrollbar-thumb {\n  background-color: #5ea1d8;\n  outline: 1px solid #5ea1d8;\n}\n\n.step-sec {\n  display: flex;\n  flex-direction: column;\n  box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n}\n// .progressbar {\n//   flex: 1;\n//   display: table;\n//   align-items: center;\n//   height:30px;\n//   background:#fff;\n// }\n.progressbar ul {\n  display: flex;\n  flex-basis: 100%;\n}\n.progressbar ul li {\n  flex: 1;\n  display: flex;\n  align-items: center;\n}\n.progressbar ul li a {\n  width: 20px;\n  height: 20px;\n  background: #5ea1d8;\n  border-radius: 50%;\n  color: #fff;\n  text-decoration: none;\n  text-align: center;\n  font-size: 12px;\n  font-family: \"RALEWAY\";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.progressbar ul li a:before {\n  counter-increment: my-sec-counter;\n  content: \"\" counter(my-sec-counter) \"\";\n}\n\nimg {\n  max-width: 100%;\n}\n\n/*new added*/\n.viewflow-step {\n  width: calc(100% - 40px);\n  display: flex;\n  padding: 20px 20px;\n  border: 1px solid #ddd;\n  box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n  position: relative;\n  border-radius: 10px;\n  flex-wrap: wrap;\n  //min-height: 300px;\n  .des-item {\n    border-radius: 0px;\n    border-right: 1px solid lightgray;\n    max-width: calc(50% - 20px);\n    padding-right: 10px;\n    .des {\n      box-shadow: none;\n      border: 0px;\n      padding: 0px 0px;\n      h6 {\n        font-weight: bold;\n        margin-bottom: 5px;\n      }\n      & > div {\n        flex: none;\n        flex-wrap: wrap;\n      }\n      p {\n        max-height: 287px;\n        padding-right: 10px;\n      }\n      .s-num {\n        font-size: 16px;\n        width: 30px;\n        height: 30px;\n        color: #fff;\n        border: 0px solid #f3f3f3;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: space-around;\n        // box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%);\n        font-family: \"Raleway\";\n        font-weight: 600;\n        margin-top: 0px;\n        margin-bottom: 20px;\n        position: relative;\n        z-index: 2;\n        &:before {\n          content: \"\";\n          width: 100%;\n          height: 100%;\n          border-radius: 50%;\n          left: 0px;\n          top: 0px;\n          position: absolute;\n          background: lightgray;\n          // border:1px solid #70bfe2;\n          z-index: -1;\n        }\n      }\n    }\n  }\n  .step-sec {\n    box-shadow: none;\n    border: 0px;\n    padding: 0px 0px 0px 0px;\n    margin-left: 10px;\n    width: 50%;\n    .progressbar {\n      border: 2px solid lightgray;\n      margin-bottom: 20px;\n      background: #fff;\n      border-radius: 10px;\n      padding: 5px;\n      // box-shadow:0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%);\n      .w3-round {\n        height: 7px;\n        background: #5ea1d8;\n        background: lightgrey;\n      }\n    }\n  }\n  // &:before{\n  //   content:\"‹\";\n\n  // background: #fafafa !important;\n  //     box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%);\n  //     width: 35px;\n  //     height: 35px;\n  //     border-radius: 50%;\n  //     display:flex;\n  //     align-items: center;\n  //     justify-content: center;\n  //     outline:none;\n  //   position:absolute;\n  // left:-49px;\n  // top: calc(50% - 20px);\n  // font-size:35px;\n\n  // }\n  // &:after{\n  //   content:\"›\";\n\n  // background: #fafafa !important;\n  //     box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%);\n  //     width: 35px;\n  //     height: 35px;\n  //     border-radius: 50%;\n  //     display:flex;\n  //     align-items: center;\n  //     justify-content: center;\n  //     outline:none;\n  //   position:absolute;\n  // right:-49px;\n  // top: calc(50% - 20px);\n  // font-size:35px;\n\n  // }\n  .clickarrow {\n    width: 100%;\n    display: block;\n    position: absolute;\n    margin-top: 0px;\n    width: 100%;\n    height: 35px;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 1;\n\n    button.owl-prev {\n      position: absolute;\n      background: #fafafa !important;\n      box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%),\n        0 1px 18px 0 rgb(0 0 0 / 12%);\n      width: 35px;\n      height: 35px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      outline: none;\n      left: -45px;\n      span {\n        font-size: 35px;\n        line-height: 0px;\n        display: flex;\n        align-items: center;\n        margin-top: -8px;\n        color: #000;\n      }\n    }\n    button.owl-next {\n      position: absolute;\n      background: #fafafa !important;\n      box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%),\n        0 1px 18px 0 rgb(0 0 0 / 12%);\n      width: 35px;\n      height: 35px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      outline: none;\n      right: -45px;\n      span {\n        font-size: 35px;\n        line-height: 0px;\n        display: flex;\n        align-items: center;\n        margin-top: -8px;\n        color: #000;\n      }\n    }\n  }\n}\n@media only screen and (max-width: 1025px) and (min-width: 320px) {\n  .view-flow {\n    // background:#fff;\n    h2 {\n      font-size: 22px !important;\n      // word-break: break-all;\n    }\n  }\n}\n@media only screen and (max-width: 992px) and (min-width: 320px) {\n  .view-flow {\n    .container1 {\n      display: flex;\n      flex-direction: column;\n      padding: 0px 15px 20px;\n      .user-sec {\n        flex-direction: row;\n        // margin:0px;\n        // padding: 0rem 0px 2rem;\n        .user-details {\n          flex-direction: column;\n          order: 2;\n          .user-ico {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n          }\n          .ico-details {\n            padding: 0px;\n            .profilepic {\n              & > div {\n                p {\n                  font-size: 14px;\n                }\n              }\n            }\n            .like {\n              display: flex;\n              flex-direction: column;\n              margin-left: 0px;\n              ul {\n                margin-left: 0px;\n                max-width: 100%;\n                margin-bottom: 10px;\n                li {\n                  i {\n                    font-size: 20px;\n                  }\n                }\n              }\n              .qrcode {\n                span {\n                  margin-right: 0px !important;\n                }\n                p {\n                  margin-bottom: 0px !important;\n                }\n              }\n            }\n          }\n        }\n        .qr-code {\n          padding: 10px 0px;\n        }\n      }\n    }\n    .description-wrapper {\n      flex-direction: column;\n      margin: 0px;\n      margin-bottom: 20px;\n      .des-item {\n        margin-right: 0px;\n        margin-bottom: 20px;\n        flex-basis: 100%;\n        max-width: unset;\n        border-right: 0px;\n        padding-right: 0px;\n        .des {\n          & > div {\n            span {\n              &:first-child {\n                justify-content: flex-start;\n              }\n            }\n          }\n          .timer-wrap {\n            display: flex;\n            flex-direction: column;\n            flex: none;\n            color: #212427;\n            > * {\n              margin-right: 10px;\n            }\n          }\n        }\n      }\n      .step-sec {\n        .img-wrap {\n          img {\n            //max-height: 300px !important;\n            // width: auto !important;\n          }\n        }\n      }\n    }\n    .viewflow-step {\n      width: 100%;\n      margin: 0px auto 20px;\n\n      .des-item {\n        flex-basis: 100%;\n        max-width: unset;\n        border-bottom: 2px solid lightgrey;\n        padding-bottom: 0px;\n        border-bottom: 0px;\n\n        .des {\n          padding-bottom: 0px;\n          // border-bottom:1px solid lightgray;\n          border-radius: 0px;\n        }\n      }\n      .step-sec {\n        padding: 0px;\n        margin-left: 0px;\n        width: 100%;\n      }\n\n      .clickarrow {\n        button {\n          width: 25px;\n          height: 25px;\n          &.owl-prev {\n            // left: -20px;\n            // background:transparent !important;\n            // box-shadow: none !important;\n          }\n          &.owl-next {\n            // right: -20px;\n            // background:transparent !important;\n            // box-shadow: none !important;\n          }\n        }\n      }\n    }\n  }\n  .qr-ico {\n    position: relative;\n    right: 0px;\n  }\n}\n\n/*table struture starts here*/\n.table-wrap {\n  max-height: 260px;\n  overflow-y: auto;\n  padding-right: 7px;\n  &::-webkit-scrollbar {\n    width: 4px;\n    height: 100px;\n  }\n  &::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: #5ea1d8;\n    outline: 1px solid #5ea1d8;\n  }\n}\ntable {\n  padding-right: 20px;\n  width: 100%;\n  tr {\n    display: flex;\n    width: 100%;\n    flex-flow: row wrap;\n    justify-content: space-between;\n    th {\n      font-family: \"Raleway\";\n      font-weight: 600 !important;\n      font-size: 16px !important;\n      width: 48%;\n      word-break: break-all;\n      margin-bottom: 15px;\n      line-height: 25px;\n    }\n    td {\n      width: 100%;\n      word-break: break-all;\n      margin-bottom: 15px;\n      font-family: \"Raleway\";\n      font-weight: 400;\n      line-height: 25px;\n      font-size: 13px;\n      position: relative;\n      padding-left: 15px;\n      display: flex;\n      & > span {\n        width: 48%;\n        overflow-wrap: break-word;\n        &:first-child {\n          margin-right: 4%;\n        }\n      }\n      &:before {\n        content: \"\";\n        width: 8px;\n        height: 8px;\n        background: grey;\n        position: absolute;\n        left: 0px;\n        top: 8px;\n        border-radius: 50%;\n        box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n      }\n      // &:nth-child(even){\n      //   &:before{\n      //     display: none;\n      //   }\n      // }\n    }\n  }\n}\n.btm-btn {\n  display: flex;\n  align-items: center;\n  & > div {\n    flex: 1;\n    &:first-child {\n      justify-content: flex-start;\n    }\n    &:last-child {\n      justify-content: right;\n      text-align: end;\n    }\n  }\n  .lock {\n    display: flex;\n    align-items: center;\n    font-family: \"Raleway\";\n    & > span {\n      display: flex;\n      align-items: center;\n    }\n  }\n}\n// .cdk-overlay-pane .mat-menu-panel{\n//   left:-250px !important;\n//   top:-19px !important;\n\n// }\n.profilepic {\n  .lock {\n    display: block;\n  }\n}\n.like-list {\n  .fashion-btn {\n    display: block;\n  }\n}\n.qr-code {\n  .lock,\n  .fashion-btn {\n    display: none;\n  }\n}\n@media only screen and (max-width: 992px) and (min-width: 461px) {\n  .view-flow {\n    .container1 {\n      .user-sec {\n        .user-details {\n          flex-direction: row;\n          // margin-bottom:30px;\n          // padding-left:15px;\n          .ico-details {\n            padding-left: 15px;\n            max-width: 100%;\n            .like {\n              ul {\n                margin-left: -15px;\n              }\n              .qrcode {\n                span {\n                  margin-right: 15px !important;\n                }\n              }\n            }\n            .profilepic {\n              & > div {\n                p {\n                  font-size: 14px !important;\n                }\n              }\n            }\n          }\n        }\n      }\n      .description-wrapper {\n        width: auto;\n        // max-width:80%;\n        // max-width:calc(100% - 50px);\n        margin: 10px 0px;\n\n        .step-sec {\n          .img-wrap {\n            max-height: unset;\n          }\n        }\n      }\n      .viewflow-step {\n        .des-item {\n          .des {\n            padding-bottom: 20px;\n            // border-bottom:1px solid lightgray;\n            border-radius: 0px;\n          }\n        }\n        .clickarrow button {\n          &.owl-next {\n            right: -35px;\n          }\n          &.owl-prev {\n            left: -35px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 992px) and (min-width: 768px) {\n  .view-flow {\n    .viewflow-step {\n      .clickarrow {\n        button {\n          width: 35px;\n          height: 35px;\n          &.owl-prev {\n            left: -45px;\n          }\n          &.owl-next {\n            right: -45px;\n          }\n        }\n      }\n    }\n  }\n}\n@media only screen and (max-width: 460px) and (min-width: 320px) {\n  .view-flow\n    .container1\n    .user-sec\n    .user-details\n    .ico-details\n    .profilepic\n    > div\n    p {\n    font-size: 11px !important;\n  }\n  .ico-details .profilepic > div:last-child {\n    span {\n      font-size: 11px;\n    }\n  }\n  .view-flow .viewflow-step .clickarrow {\n    button {\n      width: 25px;\n      height: 25px;\n      &.owl-prev {\n        left: -30px;\n        // background:transparent !important;\n        // box-shadow: none !important;\n      }\n      &.owl-next {\n        right: -30px;\n        // background:transparent !important;\n        // box-shadow: none !important;\n      }\n    }\n  }\n  .view-flow .viewflow-step {\n    width: auto;\n    margin: 10px 20px;\n  }\n  .qr-code {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    .lock {\n      > span {\n        display: flex;\n        align-items: center;\n      }\n      .priceIcon-p {\n        top: -2px;\n      }\n    }\n    .qr-ico {\n      // width: 24px;\n      // background: gray;\n      // display: block;\n      // height: 35px;\n    }\n    .lock,\n    .fashion-btn {\n      display: block;\n    }\n  }\n\n  .profilepic {\n    .lock {\n      display: none !important;\n    }\n  }\n  .like-list {\n    .fashion-btn {\n      display: none !important;\n    }\n  }\n  .view-flow h2 span {\n    font-size: 20px !important;\n    word-break: break-word;\n  }\n  .view-flow .container1 .user-sec {\n    padding: 10px;\n  }\n  .ico-details .profilepic .profinner > div {\n    margin-right: 5px;\n  }\n  .ico-details .profilepic > div {\n    margin-right: 0px;\n  }\n  .like li:last-child {\n    display: none !important;\n  }\n  .viewflow-step .des-item .des p {\n    max-height: 133px;\n  }\n  .view-flow .container1 .user-sec .user-details .ico-details .like ul li span {\n    font-size: 9px;\n  }\n}\n\nbutton.common {\n  padding: 3px 6px !important;\n  background: #5ea1d8 !important;\n\n  border: 0px !important;\n  color: #fff !important;\n  font-size: 13px !important;\n  border-radius: 5px !important;\n}\n\n@media (max-width: 500px) {\n  .ico-details .profilepic .qrcode {\n    justify-content: center;\n  }\n}\n\n.example-list {\n  max-width: 100%;\n  // border: solid 1px #ccc;\n  // min-height: 246px;\n  height: auto;\n  display: block;\n  background: white;\n  // border-radius: 4px;\n  overflow-y: auto;\n  .example-box {\n    display: flex;\n    padding: 15px 10px;\n    border-bottom: 1px solid lightgrey;\n    background: white !important;\n    .item-name {\n      text-align: left;\n      width: 70%;\n    }\n\n    .item-value {\n      text-align: left;\n      width: 30%;\n    }\n\n    .item-name,\n    .item-delete,\n    .item-reorder,\n    .item-value {\n      text-align: left;\n      padding: 5px;\n      font-size: 14px;\n      font-weight: 400 !important;\n      overflow-wrap: break-word;\n    }\n    .item-delete,\n    .item-reorder {\n      float: right;\n      cursor: pointer;\n      font-size: 20px;\n      width: 10%;\n    }\n    &:last-child {\n      border-bottom: 0px;\n    }\n  }\n  &::-webkit-scrollbar {\n    width: 4px;\n    height: 100px;\n  }\n  &::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: #5ea1d8;\n    outline: 1px solid #5ea1d8;\n  }\n}\n\n.example-box {\n  padding: 15px 10px;\n  border-bottom: solid 1px lightgray;\n  color: rgba(0, 0, 0, 0.87);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  cursor: move;\n  background: white;\n  font-size: 14px;\n  & > div {\n    width: 50%;\n    display: flex !important;\n    &:first-child {\n      width: 80%;\n    }\n    &:last-child {\n      width: 17%;\n    }\n    & > span {\n      // width:48%;\n      text-align: left;\n      word-break: keep-all;\n      display: flex;\n      align-items: center;\n\n      &:first-child {\n        flex: 1;\n        width: 50%;\n        color: rgba(0, 0, 0, 0.54) !important;\n        font-weight: 400 !important;\n      }\n      &:last-child {\n        width: 50%;\n        text-align: center;\n        display: flex;\n        align-items: center;\n        justify-content: end;\n        white-space: nowrap;\n        color: rgba(0, 0, 0, 0.54) !important;\n        font-weight: 400 !important;\n      }\n    }\n  }\n}\n.itemremove {\n  span {\n    &:first-child {\n      width: 90% !important;\n    }\n    &:nth-child(2) {\n      display: none;\n    }\n  }\n}\n\n.img-div-left {\n  position: fixed;\n  z-index: 9999999 !important;\n  height: 100px;\n  width: 100px;\n  // background: green !important;\n  overflow: visible;\n  margin: auto;\n  top: 5% !important;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  img {\n    width: 100%;\n    height: 100%;\n    position: absolute !important;\n    top: 0% !important;\n  }\n}\n\n.card {\n  height: 100px;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  transition: 0.3s;\n  width: 30%;\n}\n\n.card:hover {\n  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);\n}\n\n.card {\n  width: calc(50% - 30px);\n  box-shadow: none;\n  margin: 40px auto 0px auto;\n  height: auto !important;\n  .container {\n    padding: 5px 16px;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n  }\n}\n\n// .item {\n//   margin-right: 0px !important;\n//   margin-left: 0px !important;\n//   // width: calc(100% - 10px)!important;\n//   border: 1px solid #ddd !important;\n//   margin: 5px !important;\n//   overflow: hidden;\n//   background: #fff;\n//   position: relative;\n//   box-shadow: -2px 2px 7px hsl(0deg 6% 77% / 50%);\n//   p {\n//     text-align: left;\n//   }\n\n//   img {\n//     border: 1px solid #ddd;\n//     width: calc(100% - 10px) !important;\n//     height: 150px !important;\n//     border-radius: 0 !important;\n//     margin: 5px !important;\n//     object-fit: cover;\n//   }\n//   .with-icon {\n//     display: flex;\n//     & > div {\n//       width: 40px !important;\n//     }\n//     img {\n//       // width:100% !important;\n//       height: 30px !important;\n//       border-radius: 20px !important;\n//       object-fit: cover !important;\n//     }\n//   }\n// }\n\n/*new design starts here new bundle*/\n// .viewbundle {\n//   .step-sec {\n//     & + .row {\n//       margin-top: 40px !important;\n//       display: flex;\n//       justify-content: flex-start;\n//       width: 100%;\n//       & > div {\n//         width: 25% !important;\n//         .item {\n//           box-shadow: none !important;\n//           img {\n//             width: calc(100% - 20px) !important;\n//             object-fit: cover;\n//             margin: 10px !important;\n//           }\n//           p {\n//             padding-left: 5px;\n//             display: -webkit-box;\n//             -webkit-line-clamp: 2;\n//             -webkit-box-orient: vertical;\n//             overflow: hidden;\n//             text-overflow: ellipsis;\n//             height: 33px !important;\n//             white-space: normal;\n//             word-break: break-word;\n//           }\n//           .with-icon {\n//             display: flex;\n//             img {\n//               width: 30px !important;\n//               height: 30px !important;\n//               border-radius: 20px !important;\n//             }\n//           }\n//         }\n//       }\n//     }\n//   }\n// }\n\n@media (max-width: 460px) {\n  .viewbundle {\n    .step-sec {\n      & + .row {\n        & > div {\n          width: 50% !important;\n          .item {\n            .with-icon {\n              display: flex;\n              align-items: center;\n              & > div {\n                width: 30px !important;\n              }\n              img {\n                margin: 0px !important;\n              }\n              p {\n                padding-left: 5px !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n@media only screen and (min-width: 461px) and (max-width: 767px) {\n  .viewbundle {\n    .step-sec {\n      & + .row {\n        & > div {\n          width: 33% !important;\n          .item {\n            .with-icon {\n              display: flex;\n              align-items: center;\n              & > div {\n                width: 30px !important;\n              }\n              img {\n                margin: 0px !important;\n              }\n              p {\n                padding-left: 5px !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.bundleIcon {\n  bottom: 10px;\n  right: 10px;\n  z-index: 10;\n  width: 25px !important;\n  height: 25px !important;\n  max-width: 25px !important;\n  height: 25px !important;\n  margin-left: 10px;\n  img {\n    width: 100% !important;\n    height: auto !important;\n    object-fit: contain;\n    border: none;\n  }\n}\n\n.ico-details .profilepic .uni-wrapper {\n  display: flex;\n  width: auto;\n  align-items: center;\n  P {\n    flex: 1;\n  }\n}\n\n// .partOfBundle {\n//   padding: 0px 20px 0px;\n//   background: #fff;\n//   background: transparent;\n//   // border: 1px solid #ddd;\n//   // box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n//   margin: 0px 20px 0px 0px;\n//   border-radius: 10px;\n//   overflow-x: auto;\n// width: 100%;\n//   h2 {\n//     position: absolute;\n//   }\n//   .row {\n//     flex-wrap: nowrap !important;\n//     width: fit-content;\n//     margin-top: 0px !important;\n//   }\n//   .item {\n//     background: #fff;\n//     margin-left: 0px;\n//     width: 170px !important;\n//     & > div:first-child {\n//       img {\n//         height: 150px !important;\n//       }\n//     }\n//     & > div:last-child {\n//       p {\n//         height: 25px !important;\n//       }\n//     }\n//   }\n//   &.newdesign{\n//     display:flex;\n//     & .row{\n//       flex-wrap: wrap !important;\n//     width: -webkit-fit-content;\n//     width: -moz-fit-content;\n//     width: fit-content;\n//     margin-top: 0px !important;\n\n//     }\n//   }\n// }\n\n@media only screen and (max-width: 767px) and (min-width: 320px) {\n  .view-flow .container1 .user-sec {\n    margin: 0px;\n  }\n  .view-flow .viewflow-step {\n    margin: 10px 0px;\n  }\n  // .partOfBundle {\n  //   padding: 0px 0px 20px;\n  //   overflow: hidden;\n  // }\n  // .partOfBundle .row {\n  //   width: auto;\n  //   margin-top: 0px !important;\n  //   flex-wrap: wrap !important;\n\n  //   // justify-content: space-between;\n  //   &>div{\n  //     display:flex;\n  //     width:44.8vw;\n  //     width:160px;\n  //     margin-bottom:10px;\n  //     margin-right:10px;\n  //   }\n  //   .item{\n  //     width:100% !important;\n  //   }\n  //   &:before{\n  //     display:none !important;\n  //   }\n  // }\n  // .partOfBundle .item {\n  //   width: 150px !important;\n  //   margin: 0px !important;\n  //   box-shadow: none !important;\n  // }\n  .ico-details .profilepic .qrcode {\n    justify-content: right;\n  }\n}\n\n/*new design add 14-05-2022*/\n\n/* new common design add*/\n\n.flobycategoryadd {\n  .user-pro .flowbycategory-row {\n    width: calc(100% - 40px);\n    margin: 0px 20px !important;\n    .flowbycategory-tile {\n      width: 18.6%;\n      margin-right: 1%;\n\n      .item {\n        width: 100% !important;\n        overflow: hidden;\n        background: #fff;\n        border: 1px solid #dddddd;\n        margin: 0px;\n        margin-right: 20px;\n        margin-bottom: 20px;\n        height: 95%;\n        position: relative;\n        padding: 10px !important;\n        div {\n          margin: 0px !important;\n        }\n        p {\n          display: -webkit-box;\n          -webkit-line-clamp: 2;\n          -webkit-box-orient: vertical;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          height: 35px !important;\n          white-space: normal;\n          word-break: break-word;\n          display: flex;\n          align-items: flex-start;\n          margin-top: 0px !important;\n          line-height: 18px !important;\n          margin-left: 5px;\n          &:last-of-type {\n            // height: auto !important;\n            // font-size: 12px !important;\n          }\n        }\n        .uni-wrapper {\n          display: flex;\n          width: 100%;\n          align-items: center;\n        }\n        .with-icon {\n          width: 100%;\n          font-family: \"Raleway\";\n          display: flex;\n          align-items: center;\n          margin: 0px !important;\n          img {\n            -o-object-fit: cover;\n            object-fit: cover;\n            height: 40px !important;\n            border: 0px;\n            margin: 0px !important;\n          }\n        }\n      }\n    }\n    video.video-display[poster] {\n      height: 100% !important;\n      padding-bottom: 12%;\n      max-height: 100% !important;\n      max-width: 100% !important;\n      width: 100% !important;\n      text-align: center;\n      cursor: pointer;\n      min-height: 150px !important;\n    }\n  }\n  .mat-sidenav-content {\n    background: #efeeee !important;\n    min-height: 89vh !important;\n    padding: 2rem 3rem !important;\n    padding-top: 0px !important;\n  }\n}\n@media only screen and (max-width: 992px) and (min-width: 320px) {\n  .supportingdoc {\n    position: relative !important;\n    padding: 10px 10px 10px 0px !important;\n  }\n}\n@media only screen and (max-width: 992px) and (min-width: 768px) {\n  .flobycategoryadd {\n    .user-pro {\n      .flowbycategory-row {\n        .flowbycategory-tile {\n          max-width: 23% !important;\n          width: 23% !important;\n          // margin: 1% !important;\n        }\n      }\n    }\n  }\n  .view-flow .container1 .description-wrapper {\n    margin: 10px 20px !important;\n  }\n}\n@media only screen and (max-width: 767px) and (min-width: 320px) {\n  .flobycategoryadd {\n    .user-pro {\n      .flowbycategory-row {\n        width: 100%;\n        margin: 0px !important;\n      }\n    }\n\n    .mat-sidenav-content {\n      background: #efeeee !important;\n      min-height: 89vh !important;\n      padding: 2rem 10px !important;\n      padding-top: 0px !important;\n    }\n  }\n}\n\n@media only screen and (max-width: 767px) and (min-width: 461px) {\n  .flobycategoryadd {\n    .user-pro {\n      .flowbycategory-row {\n        .flowbycategory-tile {\n          max-width: 31.3% !important;\n          width: 31.3% !important;\n          margin: 1%;\n        }\n      }\n    }\n  }\n}\n@media screen and (max-width: 460px) {\n  .flobycategoryadd {\n    .user-pro {\n      .flowbycategory-row {\n        .flowbycategory-tile {\n          max-width: 48% !important;\n          width: 48% !important;\n          margin: 1%;\n        }\n      }\n    }\n  }\n}\n.qrcode {\n  .uni-wrapper {\n    p {\n      .common {\n        background: #e83e8c !important;\n      }\n    }\n  }\n}\n\n.view-flow .partOfBundle {\n  padding: 0px 20px 20px;\n  background: #fff;\n  background: transparent;\n  margin: 0px 20px 0px 0px;\n  border-radius: 10px;\n  overflow-x: scroll;\n  h2 {\n    font-size: 2rem;\n    line-height: 1.2;\n    margin-bottom: 0px !important;\n  }\n}\n.flobycategoryadd .user-pro .flowbycategory-row {\n  width: calc(100% - 0px);\n  margin: 0px 0px 0px 0px !important;\n}\n.newdesignadd {\n  border: 0px !important;\n  padding: 0px !important;\n  // width:100%;\n  // display: block;\n}\n.not-draggable {\n  -webkit-user-drag: none; /* Safari/Chrome */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* IE10+ */\n  user-select: none; /* Standard syntax */\n  cursor: default; /* Optional: Change the cursor style */\n  transform: translate(0, 0) !important;\n  width: 100%;\n}\n.divscroll {\n  width: 100% !important;\n  display: flex;\n  flex-direction: row;\n  height: 100px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  div {\n    width: 100% !important;\n  }\n}\n@media (max-width: 767px) {\n  .partOfBundle {\n    padding: 0px 0px 20px 0px !important;\n    margin-right: 0px !important;\n    h2 {\n      margin-top: 0px !important;\n    }\n  }\n  .view-flow .container1 .viewflow-step {\n    margin-bottom: 10px !important;\n  }\n}\n.view-flow\n  .container1\n  .user-sec\n  .user-details\n  .ico-details\n  .profilepic\n  .profinner {\n  div:nth-child(4) {\n    position: relative;\n    span {\n      position: relative !important;\n    }\n  }\n}\n@media (max-width: 767px) {\n  .priceIcon-wp {\n    position: relative !important;\n  }\n  .qr-code .fashion-btn + .fashion-btn {\n    display: none !important;\n  }\n}\n.qrcode.mobview {\n  display: none;\n}\n@media (max-width: 767px) {\n  .qrcode.mobview {\n    display: flex;\n    align-items: center;\n    p {\n      margin-bottom: 0px !important;\n    }\n  }\n  .desktopview {\n    display: none;\n  }\n}\n.btn-wrap {\n  height: 35px;\n  font-size: 14px;\n  cursor: pointer;\n  color: white;\n  background-color: #5ea1d8;\n  border-radius: 5px;\n}\n\n.action-buttons-container {\n  display: flex;\n  justify-content: center;\n  padding: 20px;\n  gap: 20px;\n}\n\n// Mobile Stacked View Styles (exact replica from view-bundle)\n.mobile-stacked-view {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 20px;\n  background: #f6f7f9;\n}\n\n.mobile-top-panel {\n  position: sticky;\n  top: 76px;\n  z-index: 3;\n  padding: 12px 0 4px;\n  background: linear-gradient(\n    180deg,\n    rgba(246, 247, 249, 0.98) 0%,\n    rgba(246, 247, 249, 0.9) 60%,\n    rgba(246, 247, 249, 0) 100%\n  );\n  backdrop-filter: blur(8px);\n}\n\n.mobile-info-panel {\n  padding: 0 12px;\n  display: flex;\n  overflow-x: auto;\n  gap: 12px;\n\n  .info-badge {\n    flex: 0 0 auto;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 12px;\n    background: #ffffff;\n    border: 1px solid #e0e0e0;\n    border-radius: 16px;\n    font-size: 13px;\n    font-weight: 500;\n    color: #606060;\n    white-space: nowrap;\n\n    &.active {\n      background: #5ea1d8;\n      color: #ffffff;\n      border-color: #5ea1d8;\n    }\n\n    .info-icon {\n      font-size: 16px;\n    }\n\n    .info-label {\n      font-family: \"Raleway\", sans-serif;\n    }\n  }\n}\n\n.mobile-info-panel::-webkit-scrollbar {\n  display: none;\n}\n\n.mobile-section {\n  background: #ffffff;\n  border-radius: 16px;\n  overflow: visible; // Changed from hidden to visible to show all content\n  scroll-margin-top: 140px;\n  \n  // Ensure media section doesn't overflow but content can\n  .mobile-media {\n    overflow: hidden;\n    border-radius: 16px 16px 0 0;\n  }\n}\n\n.mobile-media {\n  background: #000;\n\n  img,\n  video {\n    width: 100%;\n    display: block;\n    max-height: 260px;\n    object-fit: cover;\n  }\n}\n\n.mobile-media-video {\n  width: 100%;\n  max-height: 260px;\n  background: #000;\n  border: 0;\n}\n\n.mobile-section-body {\n  padding: 20px 20px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n\n  // Ensure all direct children are aligned consistently\n  > * {\n    margin-left: 0;\n    margin-right: 0;\n  }\n}\n\n.mobile-section-title {\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0;\n  padding: 0;\n  color: #1f2f46;\n  line-height: 1.4;\n}\n\n.mobile-section-description {\n  color: #4a5568;\n  line-height: 1.6;\n  margin: 0;\n  padding: 0;\n\n  p {\n    margin: 0 0 12px 0;\n    padding: 0;\n    \n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n}\n\n.mobile-meta-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin: 0;\n  padding: 0;\n\n  .channel-header {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    flex: 1;\n    min-width: 0;\n    margin: 0;\n    padding: 0;\n\n    .channel-avatar {\n      flex-shrink: 0;\n\n      img {\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        object-fit: cover;\n        cursor: pointer;\n      }\n\n      .material-icons {\n        font-size: 40px;\n        width: 40px;\n        height: 40px;\n        color: #606060;\n        cursor: pointer;\n      }\n    }\n\n    .channel-details {\n      flex: 1;\n      min-width: 0;\n      margin: 0;\n      padding: 0;\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start; // Ensure left alignment\n\n      .channel-name {\n        font-size: 14px;\n        font-weight: 500;\n        color: #0f0f0f;\n        cursor: pointer;\n        margin: 0 0 2px 0;\n        padding: 0;\n        font-family: \"Raleway\", sans-serif;\n        line-height: 1.4;\n        text-align: left;\n        width: 100%; // Ensure full width alignment\n\n        &:hover {\n          color: #606060;\n        }\n      }\n\n      .channel-meta {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n        flex-wrap: wrap;\n        font-size: 12px;\n        color: #606060;\n        font-family: \"Raleway\", sans-serif;\n        margin: 0;\n        padding: 0;\n        width: 100%; // Ensure full width alignment with channel-name\n        text-align: left;\n\n        mat-icon {\n          font-size: 14px;\n          width: 14px;\n          height: 14px;\n        }\n\n        .price-tag {\n          color: #e83e8c;\n          cursor: pointer;\n          font-weight: 500;\n\n          &:hover {\n            text-decoration: underline;\n          }\n        }\n\n        .purchased-tag {\n          color: #606060;\n          background: #f2f2f2;\n          padding: 2px 6px;\n          border-radius: 4px;\n          font-size: 11px;\n        }\n      }\n    }\n\n    .channel-actions {\n      display: flex;\n      gap: 8px;\n      flex-shrink: 0;\n\n      .follow-btn {\n        padding: 8px 14px;\n        border-radius: 18px;\n        border: 1px solid #5ea1d8;\n        font-size: 13px;\n        font-weight: 500;\n        cursor: pointer;\n        transition: background 0.2s, box-shadow 0.2s;\n        white-space: nowrap;\n\n        &.following {\n          background: #f2f8fc;\n          color: #0f0f0f;\n          border-color: #5ea1d8;\n\n          &:hover {\n            background: #e1f0fa;\n          }\n        }\n\n        &:not(.following) {\n          background: #5ea1d8;\n          color: #ffffff;\n          box-shadow: 0 4px 10px rgba(94, 161, 216, 0.35);\n\n          &:hover {\n            background: #4b8ac1;\n          }\n        }\n      }\n\n      .purchase-btn {\n        padding: 8px 14px;\n        border-radius: 18px;\n        border: none;\n        background: #e83e8c;\n        color: white;\n        font-size: 13px;\n        font-weight: 500;\n        cursor: pointer;\n        transition: background 0.2s;\n        white-space: nowrap;\n\n        &:hover {\n          background: #d0307a;\n        }\n      }\n    }\n  }\n}\n\n.mobile-actions-bar {\n  display: flex;\n  gap: 16px;\n  padding: 12px 0;\n  border-top: 1px solid #e0e0e0;\n  border-bottom: 1px solid #e0e0e0;\n  margin: 12px 0;\n\n  .action-item {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    cursor: pointer;\n    color: #606060;\n    font-size: 14px;\n\n    mat-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n    }\n\n    // Bookmark icon - show flowchest blue when saved\n    mat-icon[style*=\"#5ea1d8\"] {\n      color: #5ea1d8 !important;\n    }\n\n    .favorite-toggle-icon.liked {\n      color: #ff4d4d;\n    }\n  }\n}\n\n.mobile-supporting-doc {\n  margin-top: 12px;\n  color: #5ea1d8;\n  text-decoration: none;\n}\n\n// Recommendations list for mobile bundle flows\n.recommendations-list.mobile {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 16px;\n  width: 100%;\n  overflow: visible;\n\n  .recommendation-item {\n    display: flex;\n    gap: 12px;\n    padding: 12px;\n    border: 1px solid #e0e0e0;\n    border-radius: 12px;\n    cursor: pointer;\n    transition: background 0.2s;\n    background: #ffffff;\n    width: 100%;\n    box-sizing: border-box;\n    min-height: 90px; // Ensure minimum height is visible\n\n    &:hover {\n      background: #f9f9f9;\n      border-color: #d0d0d0;\n    }\n\n    .recommendation-thumbnail {\n      flex-shrink: 0;\n      width: 140px;\n      height: 90px;\n      min-width: 140px;\n      min-height: 90px;\n      border-radius: 8px;\n      overflow: hidden;\n      background: #000;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      img,\n      video {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n        display: block;\n      }\n    }\n\n    .recommendation-info {\n      flex: 1;\n      min-width: 0;\n      display: flex;\n      flex-direction: column;\n      gap: 6px;\n      justify-content: flex-start;\n      overflow: visible;\n\n      .recommendation-title {\n        font-size: 16px;\n        font-weight: 500;\n        margin: 0;\n        padding: 0;\n        color: #0f0f0f;\n        line-height: 20px;\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      .recommendation-meta {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-size: 12px;\n        color: #606060;\n        flex-wrap: wrap;\n        margin: 0;\n        padding: 0;\n\n        .recommendation-creator,\n        .recommendation-id {\n          font-family: \"Raleway\", sans-serif;\n          white-space: nowrap;\n        }\n      }\n\n      .recommendation-price {\n        margin-top: auto;\n        font-weight: 600;\n        color: #e83e8c;\n        font-size: 14px;\n        padding: 0;\n        margin-bottom: 0;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
